(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4056],{

/***/ 1936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ CreditTypeEnum; }
/* harmony export */ });
/* unused harmony export PledgeTypeEnum */
var CreditTypeEnum;

(function (CreditTypeEnum) {
  CreditTypeEnum["COLATERAL_FREE"] = "1";
  CreditTypeEnum["PLEDGE_AUTO"] = "2";
  CreditTypeEnum["PLEDGE_REAL_ESTATE"] = "3";
  CreditTypeEnum["NEW_AUTO"] = "4";
  CreditTypeEnum["USED_AUTO"] = "5";
})(CreditTypeEnum || (CreditTypeEnum = {}));

var PledgeTypeEnum;

(function (PledgeTypeEnum) {
  PledgeTypeEnum["REAL_ESTATE"] = "1";
  PledgeTypeEnum["AUTO"] = "2";
  PledgeTypeEnum["MOVING_PROPERTY"] = "3";
  PledgeTypeEnum["RENTED_PREMISES"] = "4";
  PledgeTypeEnum["NOTHING"] = "5";
})(PledgeTypeEnum || (PledgeTypeEnum = {}));

/***/ }),

/***/ 5521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ applicationValidationStep3Schema; },
/* harmony export */   "MP": function() { return /* binding */ applicationValidationStep1CodeSchema; },
/* harmony export */   "U": function() { return /* binding */ applicationValidationStep5Schema; },
/* harmony export */   "a2": function() { return /* binding */ applicationValidationSchema; },
/* harmony export */   "cw": function() { return /* binding */ applicationValidationStep4Schema; },
/* harmony export */   "gE": function() { return /* binding */ applicationValidationStep2Schema; },
/* harmony export */   "ro": function() { return /* binding */ applicationValidationStep1Schema; },
/* harmony export */   "ti": function() { return /* binding */ findOption; },
/* harmony export */   "vq": function() { return /* binding */ getStepperData; }
/* harmony export */ });
/* unused harmony exports creditInfoSchema, creditUsedCarSchema, creditNewCarSchema, collateralRealEstateSchema, collateralCarSchema */
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1604);
/* harmony import */ var _entities_Product_Application_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1936);


var creditInfoSchema = function creditInfoSchema(t) {
  return zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({
    credit_sum: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().trim().min(1, {
      message: t("Обязательное поле")
    }),
    credit_period: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1, {
      message: t("Выберите период")
    }),
    credit_monthly_payment: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().trim().min(1, {
      message: t("Обязательное поле")
    }),
    credit_target: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1, {
      message: t("Выберите цель кредита")
    })
  });
};
var creditUsedCarSchema = function creditUsedCarSchema() {
  return zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({
    credit_car_year: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].number */ .ZP.number().min(1900).max(2030),
    credit_car_doc_number: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1)
  });
};
var creditNewCarSchema = function creditNewCarSchema() {
  return zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({
    credit_car_brand: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1),
    credit_car_name: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1),
    credit_car_type: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1),
    credit_car_price: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1),
    advance_payment: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string()
  });
};
var collateralRealEstateSchema = function collateralRealEstateSchema() {
  return zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({
    pledge_type: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1),
    real_estate_price: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(2),
    real_estate_address_state: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1),
    real_estate_address_district: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1),
    real_estate_address_village: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string(),
    real_estate_full_address: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1)
  });
};
var collateralCarSchema = function collateralCarSchema() {
  return zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({
    collateral_car_brand: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1),
    collateral_car_name: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1),
    collateral_car_type: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1),
    collateral_car_year: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].number */ .ZP.number().min(1900).max(2030),
    collateral_car_doc_number: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1),
    collateral_car_price: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1)
  });
};
var applicationValidationStep1Schema = function applicationValidationStep1Schema(t) {
  return zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({
    phone: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string({
      required_error: t("Введите номер телефона")
    }).refine(function (value) {
      return (value === null || value === void 0 ? void 0 : value.replace(/[^0-9]/g, "").length) === 11;
    }, function () {
      return {
        message: t("Введите номер телефона")
      };
    }),
    agreement: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].literal */ .ZP.literal(true)
  });
};
var applicationValidationStep1CodeSchema = function applicationValidationStep1CodeSchema(t) {
  return zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({
    verification_code: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().refine(function (value) {
      return (value === null || value === void 0 ? void 0 : value.replace(/[^0-9]/g, "").length) === 4;
    }, function () {
      return {
        message: t("Введите код")
      };
    })
  });
};
var applicationValidationStep2Schema = function applicationValidationStep2Schema(t) {
  return zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({
    name: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().trim().min(1, {
      message: t("Обязательное поле")
    }),
    last_name: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().trim().min(1, {
      message: t("Обязательное поле")
    }),
    middle_name: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().trim().optional(),
    iin: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().refine(function (value) {
      return (value === null || value === void 0 ? void 0 : value.replace(/[^0-9]/g, "").length) === 12;
    }, function () {
      return {
        message: t("Введите ИИН")
      };
    }),
    city: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1, {
      message: t("Выберите город")
    })
  });
};
var applicationValidationStep3Schema = function applicationValidationStep3Schema(t) {
  return zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].union */ .ZP.union([zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({
    credit_type: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].literal */ .ZP.literal(_entities_Product_Application_types__WEBPACK_IMPORTED_MODULE_0__/* .CreditTypeEnum.NEW_AUTO */ .z.NEW_AUTO)
  }).and(creditInfoSchema(t)).and(creditNewCarSchema()), zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({
    credit_type: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].literal */ .ZP.literal(_entities_Product_Application_types__WEBPACK_IMPORTED_MODULE_0__/* .CreditTypeEnum.USED_AUTO */ .z.USED_AUTO)
  }).and(creditInfoSchema(t)).and(creditNewCarSchema()).and(creditUsedCarSchema()), zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({
    credit_type: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].literal */ .ZP.literal(_entities_Product_Application_types__WEBPACK_IMPORTED_MODULE_0__/* .CreditTypeEnum.COLATERAL_FREE */ .z.COLATERAL_FREE)
  }).and(creditInfoSchema(t)), zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({
    credit_type: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].literal */ .ZP.literal(_entities_Product_Application_types__WEBPACK_IMPORTED_MODULE_0__/* .CreditTypeEnum.PLEDGE_AUTO */ .z.PLEDGE_AUTO)
  }).and(creditInfoSchema(t)), zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({
    credit_type: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].literal */ .ZP.literal(_entities_Product_Application_types__WEBPACK_IMPORTED_MODULE_0__/* .CreditTypeEnum.PLEDGE_REAL_ESTATE */ .z.PLEDGE_REAL_ESTATE)
  }).and(creditInfoSchema(t))]);
};
var applicationValidationStep4Schema = function applicationValidationStep4Schema(t) {
  return zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({
    company_name: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().trim().min(1, {
      message: t("Обязательное поле")
    }),
    classification: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().min(1, {
      message: t("Выберите классификацию")
    }),
    position: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string({
      required_error: t("Обязательное поле")
    }).trim().min(1),
    working_period: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().refine(function (value) {
      return (value === null || value === void 0 ? void 0 : value.replace(/[^0-9]/g, "").length) === 8;
    }),
    month_income: zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].string */ .ZP.string().trim().min(1, {
      message: t("Обязательное поле")
    })
  });
};
var applicationValidationStep5Schema = function applicationValidationStep5Schema(productId, t) {
  if (productId === _entities_Product_Application_types__WEBPACK_IMPORTED_MODULE_0__/* .CreditTypeEnum.PLEDGE_REAL_ESTATE */ .z.PLEDGE_REAL_ESTATE) {
    return collateralRealEstateSchema();
  }

  if (productId === _entities_Product_Application_types__WEBPACK_IMPORTED_MODULE_0__/* .CreditTypeEnum.PLEDGE_AUTO */ .z.PLEDGE_AUTO) {
    return collateralCarSchema();
  }

  return zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({});
};
var applicationValidationSchema = function applicationValidationSchema(productId, t) {
  return zod__WEBPACK_IMPORTED_MODULE_1__/* ["default"].object */ .ZP.object({}).and(applicationValidationStep2Schema(t)).and(applicationValidationStep3Schema(t)).and(applicationValidationStep4Schema(t)).and(applicationValidationStep5Schema(productId, t));
};
var getStepperData = function getStepperData(step, t, productId) {
  var isStep5Visible = [_entities_Product_Application_types__WEBPACK_IMPORTED_MODULE_0__/* .CreditTypeEnum.PLEDGE_AUTO */ .z.PLEDGE_AUTO, _entities_Product_Application_types__WEBPACK_IMPORTED_MODULE_0__/* .CreditTypeEnum.PLEDGE_REAL_ESTATE */ .z.PLEDGE_REAL_ESTATE].includes(productId);

  switch (step) {
    case 0:
      return {
        step: t("\u0428\u0430\u0433 1"),
        title: t("\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u043D\u043E\u043C\u0435\u0440\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430"),
        percent: isStep5Visible ? 20 : 25
      };

    case 1:
      return {
        step: t("\u0428\u0430\u0433 1"),
        title: t("\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u043D\u043E\u043C\u0435\u0440\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430"),
        percent: isStep5Visible ? 20 : 25
      };

    case 2:
      return {
        step: t("\u0428\u0430\u0433 2"),
        title: t("\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"),
        percent: isStep5Visible ? 40 : 50
      };

    case 3:
      return {
        step: t("\u0428\u0430\u0433 3"),
        title: t("\u041A\u0440\u0435\u0434\u0438\u0442\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"),
        percent: isStep5Visible ? 60 : 75
      };

    case 4:
      return {
        step: t("\u0428\u0430\u0433 4"),
        title: t("\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u0440\u0430\u0431\u043E\u0442\u0435"),
        percent: isStep5Visible ? 80 : 100
      };

    case 5:
      return {
        step: t("\u0428\u0430\u0433 5"),
        title: t("\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u0437\u0430\u043B\u043E\u0433\u0435"),
        percent: 100
      };

    default:
      return {
        step: "",
        title: "",
        percent: 0
      };
  }
};
var findOption = function findOption(options, value) {
  return options.find(function (option) {
    return option.value === value;
  });
};

/***/ }),

/***/ 8282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CodeTimer; }
/* harmony export */ });
/* harmony import */ var _var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29);
/* harmony import */ var _var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _shared_ui_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4006);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6720);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8777);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);







function CodeTimer(_ref) {
  var sendCode = _ref.sendCode,
      className = _ref.className;

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  var interval = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      isSendAgainMessage = _useState[0],
      setIsSendAgainMessage = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(59),
      codeCounter = _useState2[0],
      setCodeCounter = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (isSendAgainMessage) {
      var tick = function tick() {
        setCodeCounter(function (prevSeconds) {
          return prevSeconds - 1;
        });
      };

      interval.current = window.setInterval(function () {
        return tick();
      }, 1000);
    }
  }, [codeCounter, isSendAgainMessage]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (codeCounter === 0) {
      clearInterval(interval.current);
      setIsSendAgainMessage(false);
      setCodeCounter(59);
    }

    return function () {
      return clearInterval(interval.current);
    };
  }, [codeCounter]);

  var sendCodeAgain = /*#__PURE__*/function () {
    var _ref2 = (0,_var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      return _var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return sendCode();

            case 2:
              setIsSendAgainMessage(true);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function sendCodeAgain() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledText, {
    className: className,
    children: isSendAgainMessage ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_shared_ui_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
      children: t("\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u043C\u043E\u0436\u043D\u043E \u0447\u0435\u0440\u0435\u0437 00:{{timer}}", {
        timer: codeCounter > 9 ? codeCounter : "0".concat(codeCounter)
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledResend, {
      onClick: sendCodeAgain,
      children: t("\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E")
    })
  });
}
var StyledText = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CodeTimer__StyledText",
  componentId: "sc-8581q5-0"
})(["display:grid;justify-content:center;"]);
var StyledResend = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_shared_ui_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z).withConfig({
  displayName: "CodeTimer__StyledResend",
  componentId: "sc-8581q5-1"
})(["text-decoration:underline;cursor:pointer;"]);

/***/ }),

/***/ 7037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ Stepper; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(8777);
// EXTERNAL MODULE: ./shared/ui/Typography/index.tsx
var Typography = __webpack_require__(4006);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./shared/ui/ProgressBar/index.tsx



function ProgressBar(_ref) {
  var percent = _ref.percent;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ProgressViewStyled, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrentProgressViewStyled, {
      $percent: percent
    })
  });
}
var ProgressViewStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProgressBar__ProgressViewStyled",
  componentId: "sc-1grwk4b-0"
})(["border-radius:0.4rem 0.4rem 0 0;height:0.4rem;background-color:#fafafa;overflow:hidden;position:relative;width:100%;"]);
var CurrentProgressViewStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProgressBar__CurrentProgressViewStyled",
  componentId: "sc-1grwk4b-1"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme,
      $percent = _ref2.$percent;
  return (0,styled_components_browser_esm/* css */.iv)(["width:", "%;height:0.4rem;border-radius:0.4rem 0.4rem 0 0;background-color:", ";position:absolute;z-index:1;transition:width 0.3s ease-out;"], $percent, theme.colors.primary_red);
});
;// CONCATENATED MODULE: ./features/Stepper/index.tsx






function Stepper(_ref) {
  var step = _ref.step,
      title = _ref.title,
      percent = _ref.percent,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledView, {
    className: className,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledHeader, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
        fontSize: "1.8rem",
        weight: 500,
        children: step
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
        color: "primary_light_gray",
        children: title
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProgressBar, {
      percent: percent
    })]
  });
}
var StyledView = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Stepper__StyledView",
  componentId: "sc-r9amsn-0"
})(["display:grid;grid-gap:2.4rem;align-content:flex-start;"]);
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Stepper__StyledHeader",
  componentId: "sc-r9amsn-1"
})(["display:grid;grid-auto-flow:column;grid-gap:1.5rem;align-items:center;justify-content:flex-start;"]);

/***/ }),

/***/ 2207:
/***/ (function(module) {

module.exports = {
  i18n: {
    locales: ["kk", "en", "ru"],
    defaultLocale: "ru",
    reloadOnPrerender: true
  }
};

/***/ }),

/***/ 4746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E4": function() { return /* binding */ extractAllExceptNumbers; },
/* harmony export */   "L0": function() { return /* binding */ getFormattedDate; },
/* harmony export */   "a3": function() { return /* binding */ splitMatchedText; },
/* harmony export */   "dX": function() { return /* binding */ setSpacesInNumber; },
/* harmony export */   "ez": function() { return /* binding */ calcMonthlyPaid; },
/* harmony export */   "gW": function() { return /* binding */ extractNumbers; },
/* harmony export */   "qc": function() { return /* binding */ extractSelectOptions; }
/* harmony export */ });
/* unused harmony exports extractLetters, getI18nPaths, getFormattedDateByRuLocale */
/* harmony import */ var date_fns_parseISO__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8420);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6159);
/* harmony import */ var _next_i18next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2207);
/* harmony import */ var _next_i18next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_next_i18next_config__WEBPACK_IMPORTED_MODULE_0__);



var setSpacesInNumber = function setSpacesInNumber(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
var extractNumbers = function extractNumbers(text) {
  return Number(text === null || text === void 0 ? void 0 : text.replace(/\D/g, ""));
};
var extractLetters = function extractLetters(text) {
  return text === null || text === void 0 ? void 0 : text.replace(/[^a-z]+/i, "");
};
var extractAllExceptNumbers = function extractAllExceptNumbers(text) {
  var _text$replace;

  return (_text$replace = text === null || text === void 0 ? void 0 : text.replace(/[0-9]/g, "")) !== null && _text$replace !== void 0 ? _text$replace : "";
};
var splitMatchedText = function splitMatchedText(search, text) {
  var regExp = new RegExp(search, "gi");
  return text.replace(regExp, function (match) {
    return "<span style=\"color: #B43432\">".concat(match, "</span>");
  });
};
var getI18nPaths = function getI18nPaths() {
  return i18nextConfig.i18n.locales.map(function (lng) {
    return {
      params: {
        locale: lng
      }
    };
  });
};
var extractSelectOptions = function extractSelectOptions(list, allOption) {
  var _list$map$sort;

  var options = (_list$map$sort = list === null || list === void 0 ? void 0 : list.map(function (item) {
    return {
      value: String(item.id),
      label: item.name,
      loan_rate: item.loan_rate
    };
  }).sort(function (a, b) {
    return Number(a.value) - Number(b.value);
  })) !== null && _list$map$sort !== void 0 ? _list$map$sort : [];

  if (allOption) {
    options.unshift({
      label: allOption,
      value: "",
      loan_rate: undefined
    });
  }

  return options;
};
var calcMonthlyPaid = function calcMonthlyPaid(term, sum, rate) {
  var rateMonth = rate / 360 * 30 / 100;
  return rateMonth * Math.pow(1 + rateMonth, term) / (Math.pow(1 + rateMonth, term) - 1) * sum;
};
var getFormattedDateByRuLocale = function getFormattedDateByRuLocale(date, dateFormat) {
  var isNeedDateConstructor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!date) return "";
  var parsingDate = isNeedDateConstructor ? new Date(date) : (0,date_fns_parseISO__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(date);
  return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(parsingDate, dateFormat);
};
var getFormattedDate = function getFormattedDate(date) {
  return getFormattedDateByRuLocale(date, "dd.MM.yyyy - HH:mm", true);
};

/***/ }),

/***/ 1639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var _var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8777);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].label.withConfig */ .ZP.label.withConfig({
  displayName: "Checkbox__StyledContainer",
  componentId: "sc-x9jryp-0"
})(["display:block;position:relative;padding-left:35px;margin-bottom:17px;cursor:pointer;font-size:1.5rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;& input{position:absolute;opacity:0;cursor:pointer;height:0;width:0;}.checkmark{position:absolute;top:0;left:0;height:1.5rem;width:1.5rem;border-radius:0.2rem;border:1px solid ", ";&:after{content:\"\";position:absolute;display:none;}}&:hover input ~ .checkmark{background-color:#ccc;}& input:checked ~ .checkmark{}& input:checked ~ .checkmark:after{display:block;content:\"\";position:absolute;width:1.1rem;height:1.1rem;top:50%;left:50%;transform:translate(-50%,-50%);border-radius:1px;background-color:", ";}& .checkmark:after{}"], function (props) {
  return props.theme.colors.basic_black;
}, function (props) {
  return props.theme.colors.basic_black;
});
var Checkbox = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (props, ref) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledContainer, {
    className: "container",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("input", _objectSpread({
      type: "checkbox",
      ref: ref
    }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: "checkmark"
    })]
  });
});

/***/ }),

/***/ 8096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ErrorMessage; }
/* harmony export */ });
/* unused harmony export StyledView */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _shared_ui_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4006);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8777);
/* harmony import */ var public_static_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2576);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);






function ErrorMessage(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledView, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(public_static_icons__WEBPACK_IMPORTED_MODULE_2__/* .ErrorIcon */ .Pz, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_shared_ui_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Typography */ .Z, {
      color: "secondary_error",
      fontSize: "1.4rem",
      children: message
    })]
  });
}
var StyledView = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ErrorMessage__StyledView",
  componentId: "sc-o1982r-0"
})(["display:grid;grid-gap:0.8rem;grid-template-columns:auto 1fr;align-items:center;margin-top:0.2rem;"]);

/***/ }),

/***/ 5571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ HorizontalFormField; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8777);
/* harmony import */ var _shared_ui_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4006);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





function HorizontalFormField(_ref) {
  var label = _ref.label,
      subLabel = _ref.subLabel,
      className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledView, {
    className: className,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledTitleWrapper, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledLabel, {
        tag: "span",
        color: "metallic_silver",
        weight: 500,
        children: label
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledSubLabel, {
        tag: "span",
        color: "metallic_silver",
        children: subLabel
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledField, {
      children: children
    })]
  });
}
var StyledView = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "HorizontalFormField__StyledView",
  componentId: "sc-1axqwo4-0"
})(["display:grid;grid-template-columns:1.2fr 1.8fr;@media screen and (max-width:", "){grid-template-columns:1fr;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledTitleWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "HorizontalFormField__StyledTitleWrapper",
  componentId: "sc-1axqwo4-1"
})(["padding:1.6rem 0;@media screen and (max-width:", "){padding:0;margin-bottom:0.2rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledField = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "HorizontalFormField__StyledField",
  componentId: "sc-1axqwo4-2"
})([""]);
var StyledLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_shared_ui_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Typography */ .Z).withConfig({
  displayName: "HorizontalFormField__StyledLabel",
  componentId: "sc-1axqwo4-3"
})(["@media screen and (max-width:", "){font-size:1.2rem;color:", ";}"], function (props) {
  return props.theme.sizes.tabletMin;
}, function (props) {
  return props.theme.colors.basic_black;
});
var StyledSubLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_shared_ui_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Typography */ .Z).withConfig({
  displayName: "HorizontalFormField__StyledSubLabel",
  componentId: "sc-1axqwo4-4"
})(["opacity:0.5;@media screen and (max-width:", "){font-size:1.2rem;opacity:1;color:", ";}"], function (props) {
  return props.theme.sizes.tabletMin;
}, function (props) {
  return props.theme.colors.basic_black;
});

/***/ }),

/***/ 4033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var _var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8777);
/* harmony import */ var _shared_ui_ErrorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8096);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3136);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);


var _excluded = ["errorMessage", "hasError"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Input = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function (_ref, ref) {
  var errorMessage = _ref.errorMessage,
      hasError = _ref.hasError,
      props = (0,_var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledView, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledInput, _objectSpread(_objectSpread({}, props), {}, {
      $hasError: hasError,
      ref: ref
    })), hasError && errorMessage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_shared_ui_ErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* .ErrorMessage */ .B, {
      message: errorMessage
    })]
  });
});
var StyledView = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div).withConfig({
  displayName: "Input__StyledView",
  componentId: "sc-qxqp76-0"
})(["max-width:100%;display:grid;justify-content:stretch;"]);
var StyledInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.input */ .E.input).withConfig({
  displayName: "Input__StyledInput",
  componentId: "sc-qxqp76-1"
})(["", ""], function (props) {
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(["padding:1.6rem;border-radius:0 1.2rem;border:1px solid ", ";background-color:", ";font-size:1.6rem;outline:none;&::placeholder{color:", ";font-size:1.6rem;}&:focus{border-color:", ";}"], props.$hasError ? props.theme.colors.secondary_error : props.theme.colors.primary_light_gray, props.theme.colors.basic_white, props.theme.colors.primary_light_gray, props.$hasError ? props.theme.colors.secondary_error : props.theme.colors.primary_red);
});

/***/ }),

/***/ 9157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8777);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3935);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1544);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3136);
/* harmony import */ var public_static_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2576);
/* harmony import */ var public_static_logo_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4343);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5893);









function Modal(_ref) {
  var show = _ref.show,
      onClose = _ref.onClose,
      children = _ref.children,
      className = _ref.className;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isBrowser = _useState[0],
      setIsBrowser = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setIsBrowser(true);
  }, []);

  var handleCloseClick = function handleCloseClick(e) {
    e.preventDefault();
    onClose();
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (show) {
      document.body.classList.add("active-modal");
    } else {
      document.body.classList.remove("active-modal");
    }
  }, [show]);

  if (isBrowser) {
    return /*#__PURE__*/react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .AnimatePresence */ .M, {
      children: show ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledModalOverlay, {
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1
        },
        exit: {
          opacity: 0
        },
        transition: {
          duration: 0.3
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledModal, {
          initial: {
            opacity: 0,
            y: 0
          },
          animate: {
            opacity: 1,
            y: 0
          },
          exit: {
            opacity: 0
          },
          transition: {
            duration: 0.3
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledMobileHeader, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledImage, {
              src: public_static_logo_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
              alt: "logo"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("button", {
              type: "button",
              onClick: handleCloseClick,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(public_static_icons__WEBPACK_IMPORTED_MODULE_2__/* .CloseIcon */ .Tw, {})
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledContent, {
            className: className,
            children: children
          })]
        })
      }) : null
    }), document.getElementById("modal-root"));
  }

  return null;
}
var StyledModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(framer_motion__WEBPACK_IMPORTED_MODULE_8__/* .motion.div */ .E.div).withConfig({
  displayName: "Modal__StyledModal",
  componentId: "sc-1e5ssi6-0"
})(["background:white;border-radius:1.2rem;padding:5.6rem 3.2rem 3.2rem 3.2rem;@media screen and (max-width:", "){border-radius:unset;padding:0 1.6rem 3.2rem;position:fixed;top:0;bottom:0;left:0;right:0;z-index:3;display:grid;grid-template-rows:auto 1fr;overflow:auto;}"], function (props) {
  return props.theme.sizes.tablet;
});
var StyledModalOverlay = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(framer_motion__WEBPACK_IMPORTED_MODULE_8__/* .motion.div */ .E.div).withConfig({
  displayName: "Modal__StyledModalOverlay",
  componentId: "sc-1e5ssi6-1"
})(["position:fixed;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;background-color:rgba(0,0,0,0.5);z-index:1000;"]);
var StyledMobileHeader = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Modal__StyledMobileHeader",
  componentId: "sc-1e5ssi6-2"
})(["display:none;@media screen and (max-width:", "){display:grid;grid-auto-flow:column;justify-content:space-between;align-items:center;width:100%;padding:0.8rem 0;}"], function (props) {
  return props.theme.sizes.tablet;
});
var StyledImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)((next_image__WEBPACK_IMPORTED_MODULE_4___default())).withConfig({
  displayName: "Modal__StyledImage",
  componentId: "sc-1e5ssi6-3"
})(["max-height:4rem;width:auto;"]);
var StyledContent = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Modal__StyledContent",
  componentId: "sc-1e5ssi6-4"
})(["@media screen and (max-width:", "){display:grid;align-content:center;justify-items:center;}"], function (props) {
  return props.theme.sizes.tablet;
});

/***/ }),

/***/ 9957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ PageBackButton; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8777);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3136);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var public_static_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2576);
/* harmony import */ var _shared_ui_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4006);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);







function PageBackButton(_ref) {
  var onClick = _ref.onClick,
      color = _ref.color,
      label = _ref.label,
      className = _ref.className;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledView, {
    className: className,
    onClick: onClick,
    $color: color,
    type: "button",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(public_static_icons__WEBPACK_IMPORTED_MODULE_1__/* .LeftCarousel */ .fp, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_shared_ui_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
      color: color,
      children: label
    })]
  });
}
var StyledView = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.button */ .E.button).withConfig({
  displayName: "PageBackButton__StyledView",
  componentId: "sc-1mzxp1q-0"
})(["display:grid;grid-gap:0.8rem;grid-auto-flow:column;justify-content:flex-start;align-items:center;svg{width:2.4rem;height:2.4rem;path{fill:", ";}}"], function (props) {
  return props.$color ? props.theme.colors[props.$color] : props.theme.colors.basic_black;
});

/***/ }),

/***/ 9320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ RadioButton; }
/* harmony export */ });
/* harmony import */ var _var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8777);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3136);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


var _excluded = ["errorMessage", "hasError", "label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var RadioButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (_ref, ref) {
  var errorMessage = _ref.errorMessage,
      hasError = _ref.hasError,
      label = _ref.label,
      props = (0,_var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledView, {
    $checked: props.checked,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("label", {
      htmlFor: props.id,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("input", _objectSpread(_objectSpread({}, props), {}, {
        type: "radio",
        ref: ref
      })), label]
    })
  });
});
var StyledView = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.span */ .E.span).withConfig({
  displayName: "RadioButton__StyledView",
  componentId: "sc-y275gj-0"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["display:block;input{display:none;}label{display:flex;align-items:center;justify-content:center;padding:1.6rem;cursor:pointer;font-size:1.6rem;font-weight:500;height:5.2rem;overflow:hidden;transition:background-color 0.2s ease;position:relative;border:1px solid ", ";color:", ";border-radius:0 1.2rem;background-color:", ";}label:hover{border-color:", ";color:", ";}"], function (props) {
    return (// @ts-ignore
      props.$checked ? theme.colors.primary_red : theme.colors.primary_light_gray
    );
  }, function (props) {
    return (// @ts-ignore
      props.$checked ? theme.colors.primary_red : theme.colors.primary_light_gray
    );
  }, function (props) {
    return props.theme.colors.basic_white;
  }, theme.colors.primary_red, theme.colors.primary_red);
});

/***/ }),

/***/ 1367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ Select; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(8777);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 172 modules
var motion = __webpack_require__(3136);
// EXTERNAL MODULE: ./shared/ui/ErrorMessage/index.tsx
var ErrorMessage = __webpack_require__(8096);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 26 modules
var react_select_esm = __webpack_require__(3691);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./shared/ui/CustormSelect/index.tsx


var _excluded = ["hasError"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var StyledSelect = (0,styled_components_browser_esm/* default */.ZP)(react_select_esm/* default */.ZP).withConfig({
  displayName: "CustormSelect__StyledSelect",
  componentId: "sc-dcybke-0"
})(["", ""], function (props) {
  return (0,styled_components_browser_esm/* css */.iv)(["min-width:0;.Select__control{border-radius:0 1.2rem;border:1px solid ", ";background-color:", ";font-size:1.6rem;&--is-focused{box-shadow:none;border-color:", ";}&--is-disabled{opacity:0.5;}&:hover{border-color:", ";}}.Select__value-container{padding:13px;}.Select__indicator-separator{display:none;}.Select__placeholder{color:", ";font-size:1.6rem;}.Select__menu{margin:0;border:none;padding:0;box-shadow:", ";border-radius:0.8rem;font-size:1.6rem;&-notice{&--no-options{padding:1.6rem;}}}.Select__option{color:", ";font-size:1.6rem;padding:1.6rem;&--is-focused{background-color:#f5f5f5;}&--is-selected{color:", ";background-color:white;}}"], props.hasError ? props.theme.colors.secondary_error : props.theme.colors.primary_light_gray, props.theme.colors.basic_white, props.hasError ? props.theme.colors.secondary_error : props.theme.colors.primary_red, props.theme.colors.primary_red, props.theme.colors.primary_light_gray, props.theme.shadow["20dp"], props.theme.colors.basic_black, props.theme.colors.primary_red);
});
function CustomSelect(_ref) {
  var hasError = _ref.hasError,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  // @ts-ignore
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSelect, _objectSpread(_objectSpread({
    classNamePrefix: "Select"
  }, props), {}, {
    hasError: hasError
  }));
}
;// CONCATENATED MODULE: ./shared/ui/Select/index.tsx


var Select_excluded = ["hasError", "errorMessage", "className"];

function Select_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Select_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Select_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Select_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







function Select(_ref) {
  var hasError = _ref.hasError,
      errorMessage = _ref.errorMessage,
      className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Select_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledView, {
    className: className,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CustomSelect, Select_objectSpread(Select_objectSpread({}, props), {}, {
      hasError: hasError
    })), hasError && errorMessage && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage/* ErrorMessage */.B, {
      message: errorMessage
    })]
  });
}
var StyledView = (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.div */.E.div).withConfig({
  displayName: "Select__StyledView",
  componentId: "sc-1m2tudo-0"
})(["max-width:100%;display:grid;justify-content:stretch;"]);

/***/ }),

/***/ 6782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ SuccessModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _shared_ui_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9157);
/* harmony import */ var public_static_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2576);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8777);
/* harmony import */ var _shared_ui_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3794);
/* harmony import */ var _shared_ui_Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4006);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5893);








function SuccessModal(_ref) {
  var show = _ref.show,
      onClose = _ref.onClose,
      title = _ref.title,
      description = _ref.description,
      buttonLabel = _ref.buttonLabel;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_ui_Modal__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u, {
    show: show,
    onClose: onClose,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledBody, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(public_static_icons__WEBPACK_IMPORTED_MODULE_2__/* .SuccessModalIcon */ .D5, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledTitle, {
        tag: "h4",
        fontSize: "2.4rem",
        weight: 700,
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledSubtitle, {
        tag: "p",
        children: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledButton, {
        onClick: onClose,
        children: buttonLabel
      })]
    })
  });
}
var StyledBody = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SuccessModal__StyledBody",
  componentId: "sc-lrrf6o-0"
})(["display:flex;flex-direction:column;align-items:center;max-width:38.6rem;@media screen and (max-width:", "){max-width:unset;}"], function (props) {
  return props.theme.sizes.tablet;
});
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_shared_ui_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .Z).withConfig({
  displayName: "SuccessModal__StyledTitle",
  componentId: "sc-lrrf6o-1"
})(["margin-top:2.4rem;margin-bottom:2rem;text-align:center;"]);
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_shared_ui_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .Z).withConfig({
  displayName: "SuccessModal__StyledSubtitle",
  componentId: "sc-lrrf6o-2"
})(["margin-bottom:4.8rem;text-align:center;"]);
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_shared_ui_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z).withConfig({
  displayName: "SuccessModal__StyledButton",
  componentId: "sc-lrrf6o-3"
})(["align-self:stretch;"]);

/***/ }),

/***/ 6102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ ApplicationPage; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(8777);
// EXTERNAL MODULE: ./shared/ui/Typography/index.tsx
var Typography = __webpack_require__(4006);
// EXTERNAL MODULE: ./shared/ui/sharedstyles.tsx
var sharedstyles = __webpack_require__(8512);
// EXTERNAL MODULE: ./features/Layout/index.tsx + 16 modules
var Layout = __webpack_require__(4999);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 14 modules
var esm = __webpack_require__(6720);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./features/Stepper/index.tsx + 1 modules
var Stepper = __webpack_require__(7037);
// EXTERNAL MODULE: ./shared/ui/SuccessModal/index.tsx
var SuccessModal = __webpack_require__(6782);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./shared/api/index.ts
var api = __webpack_require__(3824);
// EXTERNAL MODULE: ./node_modules/effector/effector.mjs
var effector = __webpack_require__(8116);
// EXTERNAL MODULE: ./entities/Product/Application/types.ts
var types = __webpack_require__(1936);
// EXTERNAL MODULE: ./shared/model/index.tsx
var model = __webpack_require__(9441);
// EXTERNAL MODULE: ./shared/lib/index.tsx
var lib = __webpack_require__(4746);
;// CONCATENATED MODULE: ./entities/Product/Application/model/index.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var sendVerificationCode = (0,effector/* createEffect */.GW)( /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,model/* verifyPhoneByCodeFx */.A$)(data);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
var resendVerificationCode = (0,effector/* createEffect */.GW)( /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(data) {
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0,model/* verifyPhoneByCodeFx */.A$)(data);

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
}());
var sendApplicationDataStep1 = (0,effector/* createEffect */.GW)( /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(data) {
    var response;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return api/* axiosInstance.post */.b.post("/applications/step-1", data);

          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x3) {
    return _ref3.apply(this, arguments);
  };
}());
var sendApplicationDataStep2 = (0,effector/* createEffect */.GW)( /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(data) {
    var response;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return api/* axiosInstance.post */.b.post("/applications/step-2", data);

          case 2:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x4) {
    return _ref4.apply(this, arguments);
  };
}());
var sendApplicationDataFinalStep = (0,effector/* createEffect */.GW)( /*#__PURE__*/function () {
  var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(data) {
    var response;
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return api/* axiosInstance.post */.b.post("/applications/step-complete", data);

          case 2:
            response = _context5.sent;
            return _context5.abrupt("return", response.data);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function (_x5) {
    return _ref5.apply(this, arguments);
  };
}());
var getDistrictsFx = (0,effector/* createEffect */.GW)( /*#__PURE__*/function () {
  var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(stateCode) {
    var response;
    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return api/* axiosInstance.get */.b.get("/dir/cities/".concat(stateCode, "/districts"));

          case 2:
            response = _context6.sent;
            return _context6.abrupt("return", response.data);

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function (_x6) {
    return _ref6.apply(this, arguments);
  };
}());
var getAddressesFx = (0,effector/* createEffect */.GW)( /*#__PURE__*/function () {
  var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(params) {
    var response;
    return regenerator_default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return api/* axiosInstance.get */.b.get("/dir/cities/".concat(params.stateCode, "/districts/").concat(params.districtCode, "/addresses"));

          case 2:
            response = _context7.sent;
            return _context7.abrupt("return", response.data);

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function (_x7) {
    return _ref7.apply(this, arguments);
  };
}());
var getCarTypesFx = (0,effector/* createEffect */.GW)( /*#__PURE__*/function () {
  var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8(brandCode) {
    var response;
    return regenerator_default().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return api/* axiosInstance.get */.b.get("/dir/brands/".concat(brandCode, "/types"));

          case 2:
            response = _context8.sent;
            return _context8.abrupt("return", response.data);

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function (_x8) {
    return _ref8.apply(this, arguments);
  };
}());
var getCarModelsFx = (0,effector/* createEffect */.GW)( /*#__PURE__*/function () {
  var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9(params) {
    var response;
    return regenerator_default().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return api/* axiosInstance.get */.b.get("/dir/brands/".concat(params.brandCode, "/types/").concat(params.typeCode, "/models"));

          case 2:
            response = _context9.sent;
            return _context9.abrupt("return", response.data);

          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function (_x9) {
    return _ref9.apply(this, arguments);
  };
}());
var getCarTypesCollateralFx = (0,effector/* attach */.ub)({
  effect: getCarTypesFx,
  mapParams: function mapParams(params) {
    return params;
  }
});
var getCarModelsCollateralFx = (0,effector/* attach */.ub)({
  effect: getCarModelsFx,
  mapParams: function mapParams(params) {
    return params;
  }
});
var getCarTypesCreditFx = (0,effector/* attach */.ub)({
  effect: getCarTypesFx,
  mapParams: function mapParams(params) {
    return params;
  }
});
var getCarModelsCreditFx = (0,effector/* attach */.ub)({
  effect: getCarModelsFx,
  mapParams: function mapParams(params) {
    return params;
  }
});
var resetApplicationForm = (0,effector/* createEvent */.yM)();
var setApplicationStep = (0,effector/* createEvent */.yM)();
var setApplicationStepPlusTwo = (0,effector/* createEvent */.yM)();
var setApplicationStepPlusOne = (0,effector/* createEvent */.yM)();
var $applicationStep = (0,effector/* createStore */.MT)(0).on(setApplicationStep, function (_, payload) {
  return payload;
}).on(setApplicationStepPlusTwo, function (state) {
  return state + 2;
}).on(setApplicationStepPlusOne, function (state) {
  return state + 1;
}).reset(resetApplicationForm);
var setSuccessModalVisibility = (0,effector/* createEvent */.yM)();
var $successModalVisibility = (0,effector/* createStore */.MT)(false).on(setSuccessModalVisibility, function (_, payload) {
  return payload;
});
var $realEstateDistricts = (0,effector/* createStore */.MT)([]).on(getDistrictsFx.doneData, function (state, payload) {
  return payload.map(function (item) {
    return {
      value: String(item.code),
      label: item.name
    };
  });
});
var $realEstateAddresses = (0,effector/* createStore */.MT)([]).on(getAddressesFx.doneData, function (state, payload) {
  return payload.map(function (item) {
    return {
      value: String(item.code),
      label: item.name
    };
  });
});
var $creditCarTypes = (0,effector/* createStore */.MT)([]).on(getCarTypesCreditFx.doneData, function (state, payload) {
  return payload.map(function (item) {
    return {
      value: String(item.code),
      label: item.name
    };
  });
});
var $creditCarModels = (0,effector/* createStore */.MT)([]).on(getCarModelsCreditFx.doneData, function (state, payload) {
  return payload.map(function (item) {
    return {
      value: String(item.code),
      label: item.name
    };
  });
});
var $collateralCarTypes = (0,effector/* createStore */.MT)([]).on(getCarTypesCollateralFx.doneData, function (state, payload) {
  return payload.map(function (item) {
    return {
      value: String(item.code),
      label: item.name
    };
  });
});
var $collateralCarModels = (0,effector/* createStore */.MT)([]).on(getCarModelsCollateralFx.doneData, function (state, payload) {
  return payload.map(function (item) {
    return {
      value: String(item.code),
      label: item.name
    };
  });
}); // step 1

var applicationStep1InitialValues = {
  phone: "",
  agreement: false
};
var submitApplicationStep1 = (0,effector/* createEvent */.yM)();
var $applicationFormStep1 = (0,effector/* createStore */.MT)(applicationStep1InitialValues).on(submitApplicationStep1, function (state, payload) {
  return payload;
}).reset(resetApplicationForm); // step 1 code

var applicationStep1CodeInitialValues = {
  verification_code: ""
};
var submitApplicationStep1Code = (0,effector/* createEvent */.yM)();
var $applicationFormStep1Code = (0,effector/* createStore */.MT)(applicationStep1CodeInitialValues).on(submitApplicationStep1Code, function (state, payload) {
  return payload;
}).reset(resetApplicationForm); // step 2 code

var applicationStep2InitialValues = {
  name: "",
  last_name: "",
  middle_name: "",
  iin: "",
  city: ""
};
var submitApplicationStep2 = (0,effector/* createEvent */.yM)();
var setCityApplicationStep2 = (0,effector/* createEvent */.yM)();
var $applicationFormStep2 = (0,effector/* createStore */.MT)(applicationStep2InitialValues).on(submitApplicationStep2, function (state, payload) {
  return payload;
}).on(setCityApplicationStep2, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    city: payload
  });
}).reset(resetApplicationForm); // step 3

var applicationStep3InitialValues = {
  credit_type: "",
  credit_sum: "",
  credit_monthly_payment: "",
  credit_period: "",
  credit_target: "",
  credit_car_brand: "",
  credit_car_name: "",
  credit_car_type: "",
  credit_car_year: "",
  credit_car_doc_number: "",
  credit_car_price: "",
  advance_payment: ""
};
var submitApplicationStep3 = (0,effector/* createEvent */.yM)();
var setCreditTypeApplicationStep3 = (0,effector/* createEvent */.yM)();
var $applicationFormStep3 = (0,effector/* createStore */.MT)(applicationStep3InitialValues).on(submitApplicationStep3, function (state, payload) {
  return payload;
}).on(setCreditTypeApplicationStep3, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    credit_type: payload
  });
}).reset(resetApplicationForm);
(0,effector/* sample */.UP)({
  source: {
    step1: $applicationFormStep1,
    step1code: $applicationFormStep1Code,
    step2: $applicationFormStep2,
    step3: $applicationFormStep3
  },
  clock: submitApplicationStep3,
  fn: function fn(_ref10) {
    var step1 = _ref10.step1,
        step1code = _ref10.step1code,
        step2 = _ref10.step2,
        step3 = _ref10.step3;
    var result = {
      verification_code: step1code.verification_code,
      product_id: step3.credit_type,
      personal: {
        phone: String((0,lib/* extractNumbers */.gW)(step1.phone)),
        name: step2.name,
        iin: step2.iin,
        last_name: step2.last_name,
        middle_name: step2.middle_name,
        city_id: step2.city
      },
      loan: {}
    };
    var loan = {
      credit_sum: String((0,lib/* extractNumbers */.gW)(step3.credit_sum)),
      credit_monthly_payment: String((0,lib/* extractNumbers */.gW)(step3.credit_monthly_payment)),
      credit_period_id: step3.credit_period,
      credit_target_id: step3.credit_target
    };
    var newAutoFields = {
      price_of_car: String((0,lib/* extractNumbers */.gW)(step3.credit_car_price)),
      brand_name: step3.credit_car_brand,
      model_name: step3.credit_car_name,
      type_name: step3.credit_car_type
    };

    var usedAutoFields = _objectSpread(_objectSpread({}, newAutoFields), {}, {
      production_year: String(step3.credit_car_year),
      technical_passport: step3.credit_car_doc_number
    });

    if (result.product_id === types/* CreditTypeEnum.NEW_AUTO */.z.NEW_AUTO) {
      Object.assign(loan, _objectSpread(_objectSpread({}, newAutoFields), {}, {
        advance_payment: String((0,lib/* extractNumbers */.gW)(step3.advance_payment))
      }));
    }

    if (result.product_id === types/* CreditTypeEnum.USED_AUTO */.z.USED_AUTO) {
      Object.assign(loan, _objectSpread(_objectSpread({}, usedAutoFields), {}, {
        advance_payment: String((0,lib/* extractNumbers */.gW)(step3.advance_payment))
      }));
    }

    return _objectSpread(_objectSpread({}, result), {}, {
      loan: loan
    });
  },
  target: sendApplicationDataStep1
}); // step 4

var applicationStep4InitialValues = {
  company_name: "",
  classification: "",
  position: "",
  working_period: "",
  month_income: ""
};
var submitApplicationStep4 = (0,effector/* createEvent */.yM)();
var setClassificationApplicationStep4 = (0,effector/* createEvent */.yM)();
var $applicationFormStep4 = (0,effector/* createStore */.MT)(applicationStep4InitialValues).on(submitApplicationStep4, function (state, payload) {
  return payload;
}).on(setClassificationApplicationStep4, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    classification: payload
  });
}).reset(resetApplicationForm);
(0,effector/* sample */.UP)({
  clock: submitApplicationStep4,
  source: {
    step1: $applicationFormStep1,
    step1code: $applicationFormStep1Code,
    step2: $applicationFormStep2,
    step3: $applicationFormStep3,
    step4: $applicationFormStep4
  },
  fn: function fn(_ref11) {
    var step1 = _ref11.step1,
        step1code = _ref11.step1code,
        step2 = _ref11.step2,
        step3 = _ref11.step3,
        step4 = _ref11.step4;
    var result = {
      verification_code: step1code.verification_code,
      product_id: step3.credit_type,
      personal: {
        phone: String((0,lib/* extractNumbers */.gW)(step1.phone)),
        name: step2.name,
        iin: step2.iin,
        last_name: step2.last_name,
        middle_name: step2.middle_name,
        city_id: step2.city
      },
      loan: {},
      job: {
        company_name: step4.company_name,
        classification_id: step4.classification,
        position: step4.position,
        month_income: String((0,lib/* extractNumbers */.gW)(step4.month_income)),
        working_period: step4.working_period
      }
    };
    var loan = {
      credit_sum: String((0,lib/* extractNumbers */.gW)(step3.credit_sum)),
      credit_monthly_payment: String((0,lib/* extractNumbers */.gW)(step3.credit_monthly_payment)),
      credit_period_id: step3.credit_period,
      credit_target_id: step3.credit_target
    };
    var newAutoFields = {
      price_of_car: String((0,lib/* extractNumbers */.gW)(step3.credit_car_price)),
      brand_name: step3.credit_car_brand,
      model_name: step3.credit_car_name,
      type_name: step3.credit_car_type
    };

    var usedAutoFields = _objectSpread(_objectSpread({}, newAutoFields), {}, {
      production_year: String(step3.credit_car_year),
      technical_passport: step3.credit_car_doc_number
    });

    if (result.product_id === types/* CreditTypeEnum.NEW_AUTO */.z.NEW_AUTO) {
      Object.assign(loan, _objectSpread(_objectSpread({}, newAutoFields), {}, {
        advance_payment: String((0,lib/* extractNumbers */.gW)(step3.advance_payment))
      }));
    }

    if (result.product_id === types/* CreditTypeEnum.USED_AUTO */.z.USED_AUTO) {
      Object.assign(loan, _objectSpread(_objectSpread({}, usedAutoFields), {}, {
        advance_payment: String((0,lib/* extractNumbers */.gW)(step3.advance_payment))
      }));
    }

    return _objectSpread(_objectSpread({}, result), {}, {
      loan: loan
    });
  },
  target: sendApplicationDataStep2
});
(0,effector/* sample */.UP)({
  clock: sendApplicationDataStep2.done,
  source: {
    currentStep: $applicationStep,
    step3: $applicationFormStep3
  },
  fn: function fn(_ref12) {
    var step3 = _ref12.step3,
        currentStep = _ref12.currentStep;
    var hasStep5 = [types/* CreditTypeEnum.PLEDGE_REAL_ESTATE */.z.PLEDGE_REAL_ESTATE, types/* CreditTypeEnum.PLEDGE_AUTO */.z.PLEDGE_AUTO].includes(step3.credit_type);

    if (hasStep5) {
      return currentStep + 1;
    }

    return currentStep + 2;
  },
  target: setApplicationStep
});
var applicationStep5InitialValues = {
  pledge_type: "",
  real_estate_price: "",
  real_estate_address_state: "",
  real_estate_address_district: "",
  real_estate_address_village: "",
  real_estate_full_address: "",
  collateral_car_brand: "",
  collateral_car_name: "",
  collateral_car_type: "",
  collateral_car_year: "",
  collateral_car_doc_number: "",
  collateral_car_price: ""
};
var submitApplicationStep5 = (0,effector/* createEvent */.yM)();
var $applicationFormStep5 = (0,effector/* createStore */.MT)(applicationStep5InitialValues).on(submitApplicationStep5, function (state, payload) {
  return payload;
}).reset(resetApplicationForm);
(0,effector/* sample */.UP)({
  source: $applicationStep,
  clock: [sendVerificationCode.done, sendApplicationDataStep1.done, submitApplicationStep2, submitApplicationStep5],
  target: setApplicationStepPlusOne
});

var applicationFormInitialState = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, applicationStep1InitialValues), applicationStep1CodeInitialValues), applicationStep2InitialValues), applicationStep3InitialValues), applicationStep4InitialValues), applicationStep5InitialValues);

var submitApplicationFinalStep = (0,effector/* createEvent */.yM)();
var $applicationFormFinalStep = (0,effector/* createStore */.MT)(applicationFormInitialState).on([$applicationFormStep1, $applicationFormStep1Code, $applicationFormStep2, $applicationFormStep3, $applicationFormStep4, $applicationFormStep5, submitApplicationFinalStep], function (state, payload) {
  return _objectSpread(_objectSpread({}, state), payload);
}).reset(resetApplicationForm);
(0,effector/* sample */.UP)({
  source: {
    state: $applicationFormFinalStep
  },
  clock: submitApplicationFinalStep,
  fn: function fn(_ref13, clock) {
    var state = _ref13.state;
    var result = {
      verification_code: state.verification_code,
      product_id: clock.credit_type,
      personal: {
        phone: String((0,lib/* extractNumbers */.gW)(state.phone)),
        name: clock.name,
        iin: clock.iin,
        last_name: clock.last_name,
        middle_name: clock.middle_name,
        city_id: clock.city
      },
      loan: {},
      job: {
        company_name: clock.company_name,
        classification_id: clock.classification,
        position: clock.position,
        month_income: String((0,lib/* extractNumbers */.gW)(clock.month_income)),
        working_period: clock.working_period
      }
    };
    var loan = {
      credit_sum: String((0,lib/* extractNumbers */.gW)(clock.credit_sum)),
      credit_monthly_payment: String((0,lib/* extractNumbers */.gW)(clock.credit_monthly_payment)),
      credit_period_id: clock.credit_period,
      credit_target_id: clock.credit_target
    };
    var collateral = {};
    var newAutoFields = {
      price_of_car: String((0,lib/* extractNumbers */.gW)(clock.credit_car_price)),
      brand_name: clock.credit_car_brand,
      model_name: clock.credit_car_name,
      type_name: clock.credit_car_type
    };

    var usedAutoFields = _objectSpread(_objectSpread({}, newAutoFields), {}, {
      production_year: String(clock.credit_car_year),
      technical_passport: clock.credit_car_doc_number
    });

    var collateralAutoFields = {
      price_of_car: String((0,lib/* extractNumbers */.gW)(clock.collateral_car_price)),
      brand_name: clock.collateral_car_brand,
      model_name: clock.collateral_car_name,
      type_name: clock.collateral_car_type,
      production_year: String(clock.collateral_car_year),
      technical_passport: clock.collateral_car_doc_number
    };
    var collateralRealEstateFields = {
      price_of_real_estate: String((0,lib/* extractNumbers */.gW)(clock.real_estate_price)),
      state: clock.real_estate_address_state,
      district: clock.real_estate_address_district,
      village: clock.real_estate_address_village,
      detail_address: clock.real_estate_full_address,
      type_of_collateral: clock.pledge_type
    };

    if (result.product_id === types/* CreditTypeEnum.NEW_AUTO */.z.NEW_AUTO) {
      Object.assign(loan, _objectSpread(_objectSpread({}, newAutoFields), {}, {
        advance_payment: String((0,lib/* extractNumbers */.gW)(clock.advance_payment))
      }));
    }

    if (result.product_id === types/* CreditTypeEnum.USED_AUTO */.z.USED_AUTO) {
      Object.assign(loan, _objectSpread(_objectSpread({}, usedAutoFields), {}, {
        advance_payment: String((0,lib/* extractNumbers */.gW)(clock.advance_payment))
      }));
    }

    if (result.product_id === types/* CreditTypeEnum.PLEDGE_REAL_ESTATE */.z.PLEDGE_REAL_ESTATE) {
      Object.assign(collateral, collateralRealEstateFields);
    }

    if (result.product_id === types/* CreditTypeEnum.PLEDGE_AUTO */.z.PLEDGE_AUTO) {
      Object.assign(collateral, collateralAutoFields);
    }

    if (Object.keys(collateral).length) {
      return _objectSpread(_objectSpread({}, result), {}, {
        loan: loan,
        collateral: collateral
      });
    }

    return _objectSpread(_objectSpread({}, result), {}, {
      loan: loan
    });
  },
  target: sendApplicationDataFinalStep
});
(0,effector/* sample */.UP)({
  clock: sendApplicationDataFinalStep.done,
  fn: function fn() {
    return true;
  },
  target: setSuccessModalVisibility
});
(0,effector/* sample */.UP)({
  clock: setSuccessModalVisibility,
  filter: function filter(clock) {
    return !clock;
  },
  fn: function fn() {
    return 0;
  },
  target: setApplicationStep
});
// EXTERNAL MODULE: ./shared/routes/index.ts
var routes = __webpack_require__(6329);
// EXTERNAL MODULE: ./entities/Product/Application/utils/index.tsx
var utils = __webpack_require__(5521);
// EXTERNAL MODULE: ./node_modules/effector-react/effector-react.mjs
var effector_react = __webpack_require__(4190);
// EXTERNAL MODULE: ./shared/ui/Button/index.tsx
var Button = __webpack_require__(3794);
// EXTERNAL MODULE: ./shared/ui/Input/index.tsx
var Input = __webpack_require__(4033);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(7333);
// EXTERNAL MODULE: ./shared/ui/HorizontalFormField/index.tsx
var HorizontalFormField = __webpack_require__(5571);
// EXTERNAL MODULE: ./shared/ui/PageBackButton/index.tsx
var PageBackButton = __webpack_require__(9957);
// EXTERNAL MODULE: ./features/CodeTimer/index.tsx
var CodeTimer = __webpack_require__(8282);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(6312);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./entities/Product/Application/ui/Step1Code/index.tsx




function Step1Code_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Step1Code_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Step1Code_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Step1Code_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















function ApplicationStep1Code() {
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var isLoadingConfirmPhone = (0,effector_react/* useUnit */.eY)(model/* confirmPhoneFx.pending */.l6.pending);

  var _useUnit = (0,effector_react/* useUnit */.eY)([$applicationFormStep1Code, submitApplicationStep1Code]),
      _useUnit2 = (0,slicedToArray/* default */.Z)(_useUnit, 2),
      step1CodeData = _useUnit2[0],
      submitStep = _useUnit2[1];

  var step1Data = (0,effector_react/* useUnit */.eY)($applicationFormStep1);
  var confirmPhone = (0,effector_react/* useUnit */.eY)(model/* confirmPhoneFx */.l6);
  var resendCode = (0,effector_react/* useUnit */.eY)(resendVerificationCode);

  var _useUnit3 = (0,effector_react/* useUnit */.eY)([$applicationStep, setApplicationStep]),
      _useUnit4 = (0,slicedToArray/* default */.Z)(_useUnit3, 2),
      activeStep = _useUnit4[0],
      setActiveStep = _useUnit4[1];

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onChange",
    shouldUnregister: false,
    resolver: (0,zod/* zodResolver */.F)((0,utils/* applicationValidationStep1CodeSchema */.MP)(t)),
    defaultValues: step1CodeData
  });

  var resendCodeHandler = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return resendCode({
                phone: step1Data.phone.replace(/[^0-9]/g, "")
              });

            case 3:
              methods.setValue("verification_code", "");
              methods.clearErrors("verification_code");
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              if (_context.t0.response.status === 429) {
                methods.setError("verification_code", {
                  message: t("Лимит попыток превышен, попробуйте через 30 минут")
                });
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function resendCodeHandler() {
      return _ref.apply(this, arguments);
    };
  }();

  var onSubmit = methods.handleSubmit( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(data) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              submitStep(data);
              _context2.next = 4;
              return confirmPhone({
                phone: step1Data.phone.replace(/[^0-9]/g, ""),
                code: data.verification_code
              });

            case 4:
              setActiveStep(activeStep + 1);
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              methods.setError("verification_code", {
                message: t("\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 SMS-\u043A\u043E\u0434")
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());

  var goBack = function goBack() {
    setActiveStep(activeStep - 1);
    methods.setValue("verification_code", "");
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledWrapper, {
    onSubmit: onSubmit,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("SMS-код"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "verification_code",
        control: methods.control,
        render: function render(_ref3) {
          var _fieldState$error, _fieldState$error2;

          var field = _ref3.field,
              fieldState = _ref3.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_number_format_es/* PatternFormat */.HH, Step1Code_objectSpread(Step1Code_objectSpread({}, field), {}, {
              hasError: Boolean((_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message),
              errorMessage: (_fieldState$error2 = fieldState.error) === null || _fieldState$error2 === void 0 ? void 0 : _fieldState$error2.message,
              format: "####",
              mask: "-",
              type: "text",
              autoComplete: "new-password",
              customInput: Input/* Input */.I
            })), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCodeTimer, {
              sendCode: resendCodeHandler
            })]
          });
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledBottom, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledPageBackButton, {
        onClick: goBack,
        color: "primary_red",
        label: t("\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430\u0437\u0430\u0434")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* Button */.z, {
        type: "submit",
        disabled: !methods.formState.isValid || isLoadingConfirmPhone,
        children: t("\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C")
      })]
    })]
  });
}
var StyledWrapper = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "Step1Code__StyledWrapper",
  componentId: "sc-ncxdsb-0"
})(["display:grid;grid-gap:2.4rem;"]);
var StyledCodeTimer = (0,styled_components_browser_esm/* default */.ZP)(CodeTimer/* CodeTimer */.x).withConfig({
  displayName: "Step1Code__StyledCodeTimer",
  componentId: "sc-ncxdsb-1"
})(["margin-top:2.4rem;text-align:center;justify-content:center;"]);
var StyledBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Step1Code__StyledBottom",
  componentId: "sc-ncxdsb-2"
})(["display:grid;margin-top:1.6rem;grid-template-columns:1.2fr 1.8fr;@media screen and (max-width:", "){grid-template-columns:1fr;grid-gap:3.2rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledPageBackButton = (0,styled_components_browser_esm/* default */.ZP)(PageBackButton/* PageBackButton */.x).withConfig({
  displayName: "Step1Code__StyledPageBackButton",
  componentId: "sc-ncxdsb-3"
})(["@media screen and (max-width:", "){width:fit-content;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
// EXTERNAL MODULE: ./shared/ui/Checkbox/index.tsx
var Checkbox = __webpack_require__(1639);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./features/Layout/model/index.tsx
var Layout_model = __webpack_require__(9411);
;// CONCATENATED MODULE: ./entities/Product/Application/ui/Step1/index.tsx




function Step1_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Step1_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Step1_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Step1_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
























function ApplicationStep1() {
  var _docs$terms;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useRouter = (0,next_router.useRouter)(),
      back = _useRouter.back;

  var docs = (0,effector_react/* useUnit */.eY)(Layout_model/* $mainDocuments */.Lk);
  var isLoadingVerifyPhone = (0,effector_react/* useUnit */.eY)(model/* sendVerificationCode.pending */.lF.pending);

  var _useUnit = (0,effector_react/* useUnit */.eY)([$applicationFormStep1, submitApplicationStep1]),
      _useUnit2 = (0,slicedToArray/* default */.Z)(_useUnit, 2),
      step1data = _useUnit2[0],
      submitStep1 = _useUnit2[1];

  var _useUnit3 = (0,effector_react/* useUnit */.eY)([$applicationStep, setApplicationStep]),
      _useUnit4 = (0,slicedToArray/* default */.Z)(_useUnit3, 2),
      activeStep = _useUnit4[0],
      setActiveStep = _useUnit4[1];

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onChange",
    shouldUnregister: false,
    resolver: (0,zod/* zodResolver */.F)((0,utils/* applicationValidationStep1Schema */.ro)(t)),
    defaultValues: step1data
  });
  var onSubmit = methods.handleSubmit( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              submitStep1(data);
              _context.next = 4;
              return (0,model/* sendVerificationCode */.lF)({
                phone: methods.getValues("phone").replace(/[^0-9]/g, "")
              });

            case 4:
              setActiveStep(activeStep + 1);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              methods.setError("phone", {
                message: t("Лимит попыток превышен, попробуйте через 30 минут")
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Step1_StyledWrapper, {
    onSubmit: onSubmit,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Номер телефона"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "phone",
        control: methods.control,
        render: function render(_ref2) {
          var _fieldState$error, _fieldState$error2;

          var field = _ref2.field,
              fieldState = _ref2.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(react_number_format_es/* PatternFormat */.HH, Step1_objectSpread(Step1_objectSpread({}, field), {}, {
            hasError: Boolean((_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message),
            errorMessage: (_fieldState$error2 = fieldState.error) === null || _fieldState$error2 === void 0 ? void 0 : _fieldState$error2.message,
            format: "+7 (###) ###-##-##",
            allowEmptyFormatting: true,
            mask: "_",
            type: "text",
            customInput: Input/* Input */.I
          }));
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Step1_StyledBottom, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Step1_StyledPageBackButton, {
        onClick: function onClick() {
          return back();
        },
        color: "primary_red",
        label: t("\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430\u0437\u0430\u0434")
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledButtonContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* Button */.z, {
          type: "submit",
          disabled: !methods.formState.isValid || isLoadingVerifyPhone,
          children: t("\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C SMS \u043A\u043E\u0434")
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledCheckbox, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, Step1_objectSpread(Step1_objectSpread({}, methods.register("agreement")), {}, {
            id: "agreement"
          })), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "agreement",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(esm/* Trans */.cC, {
                i18nKey: "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0443, \u044F \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u044E\u0441\u044C \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438 \u0441 \u041F\u0440\u0430\u0432\u0438\u043B\u0430\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u043E\u0439",
                children: ["\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0443, \u044F \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u044E\u0441\u044C \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443", /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPersonalDataLink, {
                  href: routes/* routePaths.main.article.personalData */.X.main.article.personalData,
                  target: "_blank",
                  children: "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445"
                }), "\u0438 c", /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
                  href: docs === null || docs === void 0 ? void 0 : (_docs$terms = docs.terms) === null || _docs$terms === void 0 ? void 0 : _docs$terms.url,
                  target: "_blank",
                  children: "\u041F\u0440\u0430\u0432\u0438\u043B\u0430\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F"
                }), "\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u043E\u0439"]
              })
            })
          })]
        })]
      })]
    })]
  });
}
var Step1_StyledWrapper = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "Step1__StyledWrapper",
  componentId: "sc-711j0y-0"
})(["display:grid;grid-gap:2.4rem;@media screen and (max-width:", "){grid-gap:1.6rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var Step1_StyledBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Step1__StyledBottom",
  componentId: "sc-711j0y-1"
})(["display:grid;margin-top:1.6rem;grid-template-columns:1.2fr 1.8fr;align-items:flex-start;@media screen and (max-width:", "){grid-template-columns:1fr;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var Step1_StyledPageBackButton = (0,styled_components_browser_esm/* default */.ZP)(PageBackButton/* PageBackButton */.x).withConfig({
  displayName: "Step1__StyledPageBackButton",
  componentId: "sc-711j0y-2"
})(["padding:1rem 0;@media screen and (max-width:", "){display:none;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledButtonContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Step1__StyledButtonContent",
  componentId: "sc-711j0y-3"
})(["display:grid;grid-gap:2rem;@media screen and (max-width:", "){grid-gap:2.4rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledCheckbox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Step1__StyledCheckbox",
  componentId: "sc-711j0y-4"
})(["display:grid;grid-auto-flow:column;align-items:flex-start;"]);
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Step1__StyledLink",
  componentId: "sc-711j0y-5"
})(["text-decoration:underline;"]);
var StyledPersonalDataLink = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
  displayName: "Step1__StyledPersonalDataLink",
  componentId: "sc-711j0y-6"
})(["text-decoration:underline;"]);
// EXTERNAL MODULE: ./shared/ui/RadioButton/index.tsx
var RadioButton = __webpack_require__(9320);
// EXTERNAL MODULE: ./shared/ui/Select/index.tsx + 1 modules
var Select = __webpack_require__(1367);
;// CONCATENATED MODULE: ./entities/Product/Application/ui/Step2Fields/index.tsx


function Step2Fields_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Step2Fields_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Step2Fields_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Step2Fields_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















function Step2Fields(_ref) {
  var cities = _ref.cities;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var methods = (0,index_esm/* useFormContext */.Gc)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Фамилия"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "last_name",
        control: methods.control,
        render: function render(_ref2) {
          var _fieldState$error, _fieldState$error2;

          var field = _ref2.field,
              fieldState = _ref2.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, Step2Fields_objectSpread(Step2Fields_objectSpread({}, field), {}, {
            onChange: function onChange(e) {
              return field.onChange((0,lib/* extractAllExceptNumbers */.E4)(e.target.value));
            },
            hasError: Boolean((_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message),
            errorMessage: (_fieldState$error2 = fieldState.error) === null || _fieldState$error2 === void 0 ? void 0 : _fieldState$error2.message
          }));
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Имя"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "name",
        control: methods.control,
        render: function render(_ref3) {
          var _fieldState$error3, _fieldState$error4;

          var field = _ref3.field,
              fieldState = _ref3.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, Step2Fields_objectSpread(Step2Fields_objectSpread({}, field), {}, {
            onChange: function onChange(e) {
              return field.onChange((0,lib/* extractAllExceptNumbers */.E4)(e.target.value));
            },
            hasError: Boolean((_fieldState$error3 = fieldState.error) === null || _fieldState$error3 === void 0 ? void 0 : _fieldState$error3.message),
            errorMessage: (_fieldState$error4 = fieldState.error) === null || _fieldState$error4 === void 0 ? void 0 : _fieldState$error4.message
          }));
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Отчество"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "middle_name",
        control: methods.control,
        render: function render(_ref4) {
          var _fieldState$error5, _fieldState$error6;

          var field = _ref4.field,
              fieldState = _ref4.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, Step2Fields_objectSpread(Step2Fields_objectSpread({}, field), {}, {
            onChange: function onChange(e) {
              return field.onChange((0,lib/* extractAllExceptNumbers */.E4)(e.target.value));
            },
            hasError: Boolean((_fieldState$error5 = fieldState.error) === null || _fieldState$error5 === void 0 ? void 0 : _fieldState$error5.message),
            errorMessage: (_fieldState$error6 = fieldState.error) === null || _fieldState$error6 === void 0 ? void 0 : _fieldState$error6.message
          }));
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("ИИН"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "iin",
        control: methods.control,
        render: function render(_ref5) {
          var _fieldState$error7, _fieldState$error8;

          var field = _ref5.field,
              fieldState = _ref5.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(react_number_format_es/* PatternFormat */.HH, Step2Fields_objectSpread(Step2Fields_objectSpread({}, field), {}, {
            hasError: Boolean((_fieldState$error7 = fieldState.error) === null || _fieldState$error7 === void 0 ? void 0 : _fieldState$error7.message),
            errorMessage: (_fieldState$error8 = fieldState.error) === null || _fieldState$error8 === void 0 ? void 0 : _fieldState$error8.message,
            format: "############",
            mask: "-",
            type: "text",
            customInput: Input/* Input */.I
          }));
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u043E\u0440\u043E\u0434"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: methods.control,
        name: "city",
        render: function render(_ref6) {
          var _fieldState$error9;

          var field = _ref6.field,
              fieldState = _ref6.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledRadioGroup, {
              children: cities.map(function (city) {
                return /*#__PURE__*/(0,react.createElement)(RadioButton/* RadioButton */.E, Step2Fields_objectSpread(Step2Fields_objectSpread({}, field), {}, {
                  key: city.value,
                  id: "".concat(city.value).concat(city.value),
                  value: city.value,
                  label: city.label,
                  onChange: function onChange() {
                    return field.onChange(city.value);
                  },
                  checked: (city === null || city === void 0 ? void 0 : city.value) === field.value
                }));
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCitySelect, {
              value: (0,utils/* findOption */.ti)(cities, field.value),
              onChange: function onChange(newValue) {
                return field.onChange(newValue.value);
              },
              hasError: Boolean(fieldState.error),
              errorMessage: (_fieldState$error9 = fieldState.error) === null || _fieldState$error9 === void 0 ? void 0 : _fieldState$error9.message,
              options: cities,
              placeholder: t("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u043E\u0440\u043E\u0434"),
              noOptionsMessage: function noOptionsMessage() {
                return t("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
              }
            })]
          });
        }
      })
    })]
  });
}
var StyledRadioGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Step2Fields__StyledRadioGroup",
  componentId: "sc-mjiyw9-0"
})(["display:grid;grid-template-columns:repeat(3,auto);grid-gap:1.3rem;@media screen and (max-width:", "){display:none;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledCitySelect = (0,styled_components_browser_esm/* default */.ZP)(Select/* Select */.P).withConfig({
  displayName: "Step2Fields__StyledCitySelect",
  componentId: "sc-mjiyw9-1"
})(["display:none;@media screen and (max-width:", "){display:block;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
;// CONCATENATED MODULE: ./entities/Product/Application/ui/Step2/index.tsx



function Step2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Step2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Step2_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Step2_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













function ApplicationStep2(_ref) {
  var cities = _ref.cities;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useUnit = (0,effector_react/* useUnit */.eY)([$applicationFormStep2, submitApplicationStep2]),
      _useUnit2 = (0,slicedToArray/* default */.Z)(_useUnit, 2),
      step2Data = _useUnit2[0],
      submitStep = _useUnit2[1];

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onChange",
    shouldUnregister: false,
    resolver: (0,zod/* zodResolver */.F)((0,utils/* applicationValidationStep2Schema */.gE)(t)),
    defaultValues: step2Data
  });
  var onSubmit = methods.handleSubmit(function (data) {
    submitStep(data);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Step2_StyledWrapper, {
    onSubmit: onSubmit,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, Step2_objectSpread(Step2_objectSpread({}, methods), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Step2Fields, {
        cities: cities
      })
    })), /*#__PURE__*/(0,jsx_runtime.jsxs)(Step2_StyledBottom, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* Button */.z, {
        type: "submit",
        disabled: !methods.formState.isValid,
        children: t("\u0414\u0430\u043B\u0435\u0435")
      })]
    })]
  });
}
var Step2_StyledWrapper = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "Step2__StyledWrapper",
  componentId: "sc-o9p5rr-0"
})(["display:grid;grid-gap:2.4rem;@media screen and (max-width:", "){grid-gap:1.6rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var Step2_StyledBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Step2__StyledBottom",
  componentId: "sc-o9p5rr-1"
})(["display:grid;margin-top:1.6rem;grid-template-columns:1.2fr 1.8fr;@media screen and (max-width:", "){grid-template-columns:1fr;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
;// CONCATENATED MODULE: ./entities/Product/Application/ui/CreditCarFields/index.tsx



function CreditCarFields_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CreditCarFields_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CreditCarFields_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CreditCarFields_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















function CreditCarFields(_ref) {
  var brandOptions = _ref.brandOptions;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var methods = (0,index_esm/* useFormContext */.Gc)();

  var _useUnit = (0,effector_react/* useUnit */.eY)([$creditCarTypes, $creditCarModels, getCarTypesCreditFx, getCarModelsCreditFx]),
      _useUnit2 = (0,slicedToArray/* default */.Z)(_useUnit, 4),
      typeOptions = _useUnit2[0],
      modelOptions = _useUnit2[1],
      getCarTypes = _useUnit2[2],
      getCarModels = _useUnit2[3];

  var _useUnit3 = (0,effector_react/* useUnit */.eY)([getCarTypesCreditFx.pending, getCarModelsCreditFx.pending]),
      _useUnit4 = (0,slicedToArray/* default */.Z)(_useUnit3, 2),
      isTypesLoading = _useUnit4[0],
      isModelLoading = _useUnit4[1];

  var _methods$watch = methods.watch(),
      credit_car_brand = _methods$watch.credit_car_brand;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Марка"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: methods.control,
        name: "credit_car_brand",
        render: function render(_ref2) {
          var field = _ref2.field,
              fieldState = _ref2.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* Select */.P, {
            value: (0,utils/* findOption */.ti)(brandOptions, field.value),
            onChange: function onChange(newValue) {
              field.onChange(newValue.value);
              getCarTypes(newValue.value);
              methods.setValue("credit_car_type", "");
              methods.setValue("credit_car_name", "");
            },
            hasError: Boolean(fieldState.error),
            options: brandOptions,
            placeholder: t("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u0430\u0440\u043A\u0443 \u0430\u0432\u0442\u043E"),
            noOptionsMessage: function noOptionsMessage() {
              return t("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
            }
          });
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Тип"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: methods.control,
        name: "credit_car_type",
        render: function render(_ref3) {
          var field = _ref3.field,
              fieldState = _ref3.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* Select */.P, {
            value: (0,utils/* findOption */.ti)(typeOptions, field.value),
            onChange: function onChange(newValue) {
              field.onChange(newValue.value);
              getCarModels({
                brandCode: credit_car_brand,
                typeCode: newValue.value
              });
              methods.setValue("credit_car_name", "");
            },
            hasError: Boolean(fieldState.error),
            isLoading: isTypesLoading,
            options: typeOptions,
            placeholder: t("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0430\u0432\u0442\u043E"),
            isDisabled: !methods.watch("credit_car_brand") || isTypesLoading,
            noOptionsMessage: function noOptionsMessage() {
              return t("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
            }
          });
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Модель"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: methods.control,
        name: "credit_car_name",
        render: function render(_ref4) {
          var field = _ref4.field,
              fieldState = _ref4.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* Select */.P, {
            value: (0,utils/* findOption */.ti)(modelOptions, field.value),
            onChange: function onChange(newValue) {
              return field.onChange(newValue.value);
            },
            hasError: Boolean(fieldState.error),
            options: modelOptions,
            isLoading: isModelLoading,
            placeholder: t("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u043E\u0434\u0435\u043B\u044C \u0430\u0432\u0442\u043E"),
            isDisabled: !methods.watch("credit_car_type") || isModelLoading,
            noOptionsMessage: function noOptionsMessage() {
              return t("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
            }
          });
        }
      })
    }), methods.getValues("credit_type") === types/* CreditTypeEnum.USED_AUTO */.z.USED_AUTO && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
        label: t("Год производства"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          name: "credit_car_year",
          control: methods.control,
          render: function render(_ref5) {
            var _fieldState$error;

            var field = _ref5.field,
                fieldState = _ref5.fieldState;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, CreditCarFields_objectSpread(CreditCarFields_objectSpread({}, field), {}, {
              onChange: function onChange(e) {
                return field.onChange((0,lib/* extractNumbers */.gW)(e.target.value));
              },
              hasError: Boolean((_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message)
            }));
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
        label: t("Номер тех. паспорта"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          name: "credit_car_doc_number",
          control: methods.control,
          render: function render(_ref6) {
            var _fieldState$error2;

            var field = _ref6.field,
                fieldState = _ref6.fieldState;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, CreditCarFields_objectSpread(CreditCarFields_objectSpread({}, field), {}, {
              hasError: Boolean((_fieldState$error2 = fieldState.error) === null || _fieldState$error2 === void 0 ? void 0 : _fieldState$error2.message)
            }));
          }
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Цена авто"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "credit_car_price",
        control: methods.control,
        render: function render(_ref7) {
          var _fieldState$error3;

          var field = _ref7.field,
              fieldState = _ref7.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, CreditCarFields_objectSpread(CreditCarFields_objectSpread({}, field), {}, {
            onChange: function onChange(e) {
              return field.onChange((0,lib/* setSpacesInNumber */.dX)((0,lib/* extractNumbers */.gW)(e.target.value)));
            },
            inputMode: "numeric",
            hasError: Boolean((_fieldState$error3 = fieldState.error) === null || _fieldState$error3 === void 0 ? void 0 : _fieldState$error3.message)
          }));
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Первоначальный взнос"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "advance_payment",
        control: methods.control,
        render: function render(_ref8) {
          var field = _ref8.field;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, CreditCarFields_objectSpread(CreditCarFields_objectSpread({}, field), {}, {
            onChange: function onChange(e) {
              return field.onChange((0,lib/* setSpacesInNumber */.dX)((0,lib/* extractNumbers */.gW)(e.target.value)));
            },
            disabled: true
          }));
        }
      })
    })]
  });
}
;// CONCATENATED MODULE: ./entities/Product/Application/ui/Step3Fields/index.tsx


function Step3Fields_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Step3Fields_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Step3Fields_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Step3Fields_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














function Step3Fields(_ref) {
  var periodOptions = _ref.periodOptions,
      creditAimOptions = _ref.creditAimOptions,
      creditTypeOptions = _ref.creditTypeOptions,
      carBrandOptions = _ref.carBrandOptions;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var methods = (0,index_esm/* useFormContext */.Gc)();
  (0,react.useEffect)(function () {
    var _methods$getValues = methods.getValues(),
        credit_type = _methods$getValues.credit_type,
        credit_period = _methods$getValues.credit_period,
        credit_sum = _methods$getValues.credit_sum;

    if (credit_type && credit_period && credit_sum) {
      var creditOption = (0,utils/* findOption */.ti)(creditTypeOptions, credit_type);
      var periodOption = (0,utils/* findOption */.ti)(periodOptions, credit_period);
      var period = (0,lib/* extractNumbers */.gW)(periodOption.label);
      var rate = creditOption === null || creditOption === void 0 ? void 0 : creditOption.loan_rate;
      var sum = (0,lib/* extractNumbers */.gW)(credit_sum);
      methods.setValue("credit_monthly_payment", String((0,lib/* setSpacesInNumber */.dX)(Math.ceil((0,lib/* calcMonthlyPaid */.ez)(period, sum, rate)))));
    }
  }, [methods.watch("credit_type"), methods.watch("credit_period"), methods.watch("credit_sum")]);
  (0,react.useEffect)(function () {
    var _methods$watch = methods.watch(),
        credit_sum = _methods$watch.credit_sum,
        credit_car_price = _methods$watch.credit_car_price;

    if (credit_sum && credit_car_price) {
      var value = Number((0,lib/* extractNumbers */.gW)(credit_car_price)) - Number((0,lib/* extractNumbers */.gW)(credit_sum));
      methods.setValue("advance_payment", String(value > 0 ? (0,lib/* setSpacesInNumber */.dX)(value) : 0));
    }
  }, [methods.watch("credit_sum"), methods.watch("credit_car_price")]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("\u0412\u0438\u0434 \u043A\u0440\u0435\u0434\u0438\u0442\u043E\u0432\u0430\u043D\u0438\u044F"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: methods.control,
        name: "credit_type",
        render: function render(_ref2) {
          var _fieldState$error;

          var field = _ref2.field,
              fieldState = _ref2.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* Select */.P, {
            value: (0,utils/* findOption */.ti)(creditTypeOptions, field.value),
            onChange: function onChange(newValue) {
              return methods.setValue("credit_type", newValue.value);
            },
            hasError: Boolean(fieldState.error),
            errorMessage: (_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message,
            options: creditTypeOptions,
            placeholder: t("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0438\u0434 \u043A\u0440\u0435\u0434\u0438\u0442\u043E\u0432\u0430\u043D\u0438\u044F"),
            noOptionsMessage: function noOptionsMessage() {
              return t("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
            }
          });
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Сумма микрокредита"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "credit_sum",
        control: methods.control,
        render: function render(_ref3) {
          var _fieldState$error2;

          var field = _ref3.field,
              fieldState = _ref3.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, Step3Fields_objectSpread(Step3Fields_objectSpread({}, field), {}, {
            onChange: function onChange(e) {
              return field.onChange((0,lib/* setSpacesInNumber */.dX)((0,lib/* extractNumbers */.gW)(e.target.value)));
            },
            inputMode: "numeric",
            hasError: Boolean((_fieldState$error2 = fieldState.error) === null || _fieldState$error2 === void 0 ? void 0 : _fieldState$error2.message)
          }));
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Срок микрокредита"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: methods.control,
        name: "credit_period",
        render: function render(_ref4) {
          var _fieldState$error3;

          var field = _ref4.field,
              fieldState = _ref4.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* Select */.P, {
            value: (0,utils/* findOption */.ti)(periodOptions, field.value),
            onChange: function onChange(newValue) {
              return methods.setValue("credit_period", newValue.value);
            },
            hasError: Boolean(fieldState.error),
            errorMessage: (_fieldState$error3 = fieldState.error) === null || _fieldState$error3 === void 0 ? void 0 : _fieldState$error3.message,
            options: periodOptions,
            placeholder: t("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u0435\u0440\u0438\u043E\u0434"),
            noOptionsMessage: function noOptionsMessage() {
              return t("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
            }
          });
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Ежемесячный платеж"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "credit_monthly_payment",
        control: methods.control,
        render: function render(_ref5) {
          var field = _ref5.field;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, Step3Fields_objectSpread(Step3Fields_objectSpread({}, field), {}, {
            onChange: function onChange(e) {
              return field.onChange((0,lib/* setSpacesInNumber */.dX)((0,lib/* extractNumbers */.gW)(e.target.value)));
            },
            disabled: true
          }));
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Цель микрокредита"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: methods.control,
        name: "credit_target",
        render: function render(_ref6) {
          var _fieldState$error4;

          var field = _ref6.field,
              fieldState = _ref6.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* Select */.P, {
            value: (0,utils/* findOption */.ti)(creditAimOptions, field.value),
            onChange: function onChange(newValue) {
              field.onChange(newValue.value);
              methods.trigger("credit_target");
            },
            hasError: Boolean(fieldState.error),
            errorMessage: (_fieldState$error4 = fieldState.error) === null || _fieldState$error4 === void 0 ? void 0 : _fieldState$error4.message,
            options: creditAimOptions,
            placeholder: t("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0446\u0435\u043B\u044C"),
            noOptionsMessage: function noOptionsMessage() {
              return t("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
            }
          });
        }
      })
    }), [types/* CreditTypeEnum.NEW_AUTO */.z.NEW_AUTO, types/* CreditTypeEnum.USED_AUTO */.z.USED_AUTO].includes(methods.watch("credit_type")) && /*#__PURE__*/(0,jsx_runtime.jsx)(CreditCarFields, {
      brandOptions: carBrandOptions
    })]
  });
}
;// CONCATENATED MODULE: ./entities/Product/Application/ui/Step3/index.tsx



function Step3_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Step3_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Step3_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Step3_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














function ApplicationStep3(_ref) {
  var periodOptions = _ref.periodOptions,
      creditAimOptions = _ref.creditAimOptions,
      creditTypeOptions = _ref.creditTypeOptions,
      carBrandOptions = _ref.carBrandOptions;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var isLoadingSendStep1 = (0,effector_react/* useUnit */.eY)(sendApplicationDataStep1.pending);

  var _useUnit = (0,effector_react/* useUnit */.eY)([$applicationFormStep3, submitApplicationStep3, $applicationStep, setApplicationStep]),
      _useUnit2 = (0,slicedToArray/* default */.Z)(_useUnit, 4),
      step3Data = _useUnit2[0],
      submitStep = _useUnit2[1],
      activeStep = _useUnit2[2],
      setActiveStep = _useUnit2[3];

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onChange",
    shouldUnregister: false,
    resolver: (0,zod/* zodResolver */.F)((0,utils/* applicationValidationStep3Schema */.Do)(t)),
    defaultValues: step3Data
  });
  var onSubmit = methods.handleSubmit(function (data) {
    submitStep(data);
  });

  var goBack = function goBack() {
    setActiveStep(activeStep - 1);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Step3_StyledWrapper, {
    onSubmit: onSubmit,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, Step3_objectSpread(Step3_objectSpread({}, methods), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Step3Fields, {
        periodOptions: periodOptions,
        creditAimOptions: creditAimOptions,
        creditTypeOptions: creditTypeOptions,
        carBrandOptions: carBrandOptions
      })
    })), /*#__PURE__*/(0,jsx_runtime.jsxs)(Step3_StyledBottom, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Step3_StyledPageBackButton, {
        onClick: goBack,
        color: "primary_red",
        label: t("\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430\u0437\u0430\u0434")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* Button */.z, {
        type: "submit",
        disabled: !methods.formState.isValid || isLoadingSendStep1,
        children: t("\u0414\u0430\u043B\u0435\u0435")
      })]
    })]
  });
}
var Step3_StyledWrapper = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "Step3__StyledWrapper",
  componentId: "sc-ldu3ry-0"
})(["display:grid;grid-gap:2.4rem;@media screen and (max-width:", "){grid-gap:1.6rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var Step3_StyledBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Step3__StyledBottom",
  componentId: "sc-ldu3ry-1"
})(["display:grid;margin-top:1.6rem;grid-template-columns:1.2fr 1.8fr;@media screen and (max-width:", "){grid-template-columns:1fr;grid-gap:3.2rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var Step3_StyledPageBackButton = (0,styled_components_browser_esm/* default */.ZP)(PageBackButton/* PageBackButton */.x).withConfig({
  displayName: "Step3__StyledPageBackButton",
  componentId: "sc-ldu3ry-2"
})(["@media screen and (max-width:", "){width:fit-content;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
;// CONCATENATED MODULE: ./entities/Product/Application/ui/Step4Fields/index.tsx


function Step4Fields_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Step4Fields_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Step4Fields_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Step4Fields_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















function Step4Fields(_ref) {
  var classificationOptions = _ref.classificationOptions;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var methods = (0,index_esm/* useFormContext */.Gc)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Название компании"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "company_name",
        control: methods.control,
        render: function render(_ref2) {
          var _fieldState$error, _fieldState$error2;

          var field = _ref2.field,
              fieldState = _ref2.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, Step4Fields_objectSpread(Step4Fields_objectSpread({}, field), {}, {
            hasError: Boolean((_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message),
            errorMessage: (_fieldState$error2 = fieldState.error) === null || _fieldState$error2 === void 0 ? void 0 : _fieldState$error2.message
          }));
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Вид деятельности"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: methods.control,
        name: "classification",
        render: function render(_ref3) {
          var _fieldState$error3;

          var field = _ref3.field,
              fieldState = _ref3.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Step4Fields_StyledRadioGroup, {
              children: classificationOptions.map(function (item) {
                return /*#__PURE__*/(0,react.createElement)(RadioButton/* RadioButton */.E, Step4Fields_objectSpread(Step4Fields_objectSpread({}, field), {}, {
                  onChange: function onChange() {
                    return field.onChange(item.value);
                  },
                  key: item.value,
                  id: item.value,
                  value: item.value,
                  label: item.label,
                  checked: (item === null || item === void 0 ? void 0 : item.value) === field.value
                }));
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSelect, {
              value: (0,utils/* findOption */.ti)(classificationOptions, field.value),
              onChange: function onChange(newValue) {
                return field.onChange(newValue.value);
              },
              hasError: Boolean(fieldState.error),
              errorMessage: (_fieldState$error3 = fieldState.error) === null || _fieldState$error3 === void 0 ? void 0 : _fieldState$error3.message,
              options: classificationOptions,
              placeholder: t("\u0412\u0438\u0434 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438"),
              noOptionsMessage: function noOptionsMessage() {
                return t("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
              }
            })]
          });
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Должность"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "position",
        control: methods.control,
        render: function render(_ref4) {
          var _fieldState$error4;

          var field = _ref4.field,
              fieldState = _ref4.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, Step4Fields_objectSpread(Step4Fields_objectSpread({}, field), {}, {
            hasError: Boolean((_fieldState$error4 = fieldState.error) === null || _fieldState$error4 === void 0 ? void 0 : _fieldState$error4.message)
          }));
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Общий период работы(месяцы)"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "working_period",
        control: methods.control,
        render: function render(_ref5) {
          var _fieldState$error5;

          var field = _ref5.field,
              fieldState = _ref5.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(react_number_format_es/* PatternFormat */.HH, Step4Fields_objectSpread(Step4Fields_objectSpread({}, field), {}, {
            hasError: Boolean((_fieldState$error5 = fieldState.error) === null || _fieldState$error5 === void 0 ? void 0 : _fieldState$error5.message),
            format: "##.##.####",
            mask: "_",
            allowEmptyFormatting: true,
            type: "text",
            customInput: Input/* Input */.I
          }));
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Месячный доход"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "month_income",
        control: methods.control,
        render: function render(_ref6) {
          var _fieldState$error6;

          var field = _ref6.field,
              fieldState = _ref6.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, Step4Fields_objectSpread(Step4Fields_objectSpread({}, field), {}, {
            onChange: function onChange(e) {
              return field.onChange((0,lib/* setSpacesInNumber */.dX)((0,lib/* extractNumbers */.gW)(e.target.value)));
            },
            inputMode: "numeric",
            hasError: Boolean((_fieldState$error6 = fieldState.error) === null || _fieldState$error6 === void 0 ? void 0 : _fieldState$error6.message)
          }));
        }
      })
    })]
  });
}
var Step4Fields_StyledRadioGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Step4Fields__StyledRadioGroup",
  componentId: "sc-bpgxar-0"
})(["display:grid;grid-template-columns:repeat(2,auto);grid-gap:1.3rem;@media screen and (max-width:", "){display:none;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledSelect = (0,styled_components_browser_esm/* default */.ZP)(Select/* Select */.P).withConfig({
  displayName: "Step4Fields__StyledSelect",
  componentId: "sc-bpgxar-1"
})(["display:none;@media screen and (max-width:", "){display:block;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
;// CONCATENATED MODULE: ./entities/Product/Application/ui/Step4/index.tsx



function Step4_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Step4_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Step4_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Step4_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














function ApplicationStep4(_ref) {
  var classificationOptions = _ref.classificationOptions;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var isLoadingSendStep2 = (0,effector_react/* useUnit */.eY)(sendApplicationDataStep2.pending);

  var _useUnit = (0,effector_react/* useUnit */.eY)([$applicationFormStep4, submitApplicationStep4, $applicationStep, setApplicationStep]),
      _useUnit2 = (0,slicedToArray/* default */.Z)(_useUnit, 4),
      step4Data = _useUnit2[0],
      submitStep = _useUnit2[1],
      activeStep = _useUnit2[2],
      setActiveStep = _useUnit2[3];

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onChange",
    shouldUnregister: false,
    resolver: (0,zod/* zodResolver */.F)((0,utils/* applicationValidationStep4Schema */.cw)(t)),
    defaultValues: step4Data
  });
  var onSubmit = methods.handleSubmit(function (data) {
    submitStep(data);
  });

  var goBack = function goBack() {
    setActiveStep(activeStep - 1);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Step4_StyledWrapper, {
    onSubmit: onSubmit,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, Step4_objectSpread(Step4_objectSpread({}, methods), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Step4Fields, {
        classificationOptions: classificationOptions
      })
    })), /*#__PURE__*/(0,jsx_runtime.jsxs)(Step4_StyledBottom, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Step4_StyledPageBackButton, {
        onClick: goBack,
        color: "primary_red",
        label: t("\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430\u0437\u0430\u0434")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* Button */.z, {
        type: "submit",
        disabled: !methods.formState.isValid || isLoadingSendStep2,
        children: t("\u0414\u0430\u043B\u0435\u0435")
      })]
    })]
  });
}
var Step4_StyledWrapper = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "Step4__StyledWrapper",
  componentId: "sc-bmouiu-0"
})(["display:grid;grid-gap:2.4rem;@media screen and (max-width:", "){grid-gap:1.6rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var Step4_StyledBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Step4__StyledBottom",
  componentId: "sc-bmouiu-1"
})(["display:grid;margin-top:1.6rem;grid-template-columns:1.2fr 1.8fr;@media screen and (max-width:", "){grid-template-columns:1fr;grid-gap:3.2rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var Step4_StyledPageBackButton = (0,styled_components_browser_esm/* default */.ZP)(PageBackButton/* PageBackButton */.x).withConfig({
  displayName: "Step4__StyledPageBackButton",
  componentId: "sc-bmouiu-2"
})(["@media screen and (max-width:", "){width:fit-content;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
;// CONCATENATED MODULE: ./entities/Product/Application/ui/CollateralCarFields/index.tsx



function CollateralCarFields_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CollateralCarFields_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CollateralCarFields_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CollateralCarFields_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














function CollateralCarFields(_ref) {
  var brandOptions = _ref.brandOptions;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var methods = (0,index_esm/* useFormContext */.Gc)();

  var _useUnit = (0,effector_react/* useUnit */.eY)([$collateralCarTypes, $collateralCarModels, getCarTypesCollateralFx, getCarModelsCollateralFx]),
      _useUnit2 = (0,slicedToArray/* default */.Z)(_useUnit, 4),
      typeOptions = _useUnit2[0],
      modelOptions = _useUnit2[1],
      getCarTypes = _useUnit2[2],
      getCarModels = _useUnit2[3];

  var _useUnit3 = (0,effector_react/* useUnit */.eY)([getCarTypesCollateralFx.pending, getCarModelsCollateralFx.pending]),
      _useUnit4 = (0,slicedToArray/* default */.Z)(_useUnit3, 2),
      isTypesLoading = _useUnit4[0],
      isModelLoading = _useUnit4[1];

  var _methods$watch = methods.watch(),
      collateral_car_brand = _methods$watch.collateral_car_brand;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Марка"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: methods.control,
        name: "collateral_car_brand",
        render: function render(_ref2) {
          var field = _ref2.field,
              fieldState = _ref2.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* Select */.P, {
            value: (0,utils/* findOption */.ti)(brandOptions, field.value),
            onChange: function onChange(newValue) {
              field.onChange(newValue.value);
              getCarTypes(newValue.value);
              methods.setValue("collateral_car_type", "");
              methods.setValue("collateral_car_name", "");
            },
            hasError: Boolean(fieldState.error),
            options: brandOptions,
            placeholder: t("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u0430\u0440\u043A\u0443 \u0430\u0432\u0442\u043E"),
            noOptionsMessage: function noOptionsMessage() {
              return t("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
            }
          });
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Тип"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: methods.control,
        name: "collateral_car_type",
        render: function render(_ref3) {
          var field = _ref3.field,
              fieldState = _ref3.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* Select */.P, {
            value: (0,utils/* findOption */.ti)(typeOptions, field.value),
            onChange: function onChange(newValue) {
              field.onChange(newValue.value);
              getCarModels({
                brandCode: collateral_car_brand,
                typeCode: newValue.value
              });
              methods.setValue("collateral_car_name", "");
            },
            hasError: Boolean(fieldState.error),
            isLoading: isTypesLoading,
            options: typeOptions,
            placeholder: t("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0430\u0432\u0442\u043E"),
            isDisabled: !methods.watch("collateral_car_brand") || isTypesLoading,
            noOptionsMessage: function noOptionsMessage() {
              return t("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
            }
          });
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Модель"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: methods.control,
        name: "collateral_car_name",
        render: function render(_ref4) {
          var field = _ref4.field,
              fieldState = _ref4.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* Select */.P, {
            value: (0,utils/* findOption */.ti)(modelOptions, field.value),
            onChange: function onChange(newValue) {
              return field.onChange(newValue.value);
            },
            hasError: Boolean(fieldState.error),
            options: modelOptions,
            isLoading: isModelLoading,
            placeholder: t("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u043E\u0434\u0435\u043B\u044C \u0430\u0432\u0442\u043E"),
            isDisabled: !methods.watch("collateral_car_type") || isModelLoading,
            noOptionsMessage: function noOptionsMessage() {
              return t("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
            }
          });
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Год производства"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "collateral_car_year",
        control: methods.control,
        render: function render(_ref5) {
          var _fieldState$error;

          var field = _ref5.field,
              fieldState = _ref5.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, CollateralCarFields_objectSpread(CollateralCarFields_objectSpread({}, field), {}, {
            onChange: function onChange(e) {
              return field.onChange((0,lib/* extractNumbers */.gW)(e.target.value));
            },
            hasError: Boolean((_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message)
          }));
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Номер тех. паспорта"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "collateral_car_doc_number",
        control: methods.control,
        render: function render(_ref6) {
          var _fieldState$error2;

          var field = _ref6.field,
              fieldState = _ref6.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, CollateralCarFields_objectSpread(CollateralCarFields_objectSpread({}, field), {}, {
            hasError: Boolean((_fieldState$error2 = fieldState.error) === null || _fieldState$error2 === void 0 ? void 0 : _fieldState$error2.message)
          }));
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Цена авто"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "collateral_car_price",
        control: methods.control,
        render: function render(_ref7) {
          var _fieldState$error3;

          var field = _ref7.field,
              fieldState = _ref7.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, CollateralCarFields_objectSpread(CollateralCarFields_objectSpread({}, field), {}, {
            onChange: function onChange(e) {
              return field.onChange((0,lib/* setSpacesInNumber */.dX)((0,lib/* extractNumbers */.gW)(e.target.value)));
            },
            inputMode: "numeric",
            hasError: Boolean((_fieldState$error3 = fieldState.error) === null || _fieldState$error3 === void 0 ? void 0 : _fieldState$error3.message)
          }));
        }
      })
    })]
  });
}
;// CONCATENATED MODULE: ./entities/Product/Application/ui/CollateralRealEstateFields/index.tsx



function CollateralRealEstateFields_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CollateralRealEstateFields_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CollateralRealEstateFields_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CollateralRealEstateFields_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














function CollateralRealEstateFields(_ref) {
  var stateOptions = _ref.stateOptions,
      pledgeTypes = _ref.pledgeTypes;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      watch = _useFormContext.watch,
      setValue = _useFormContext.setValue,
      control = _useFormContext.control;

  var _useUnit = (0,effector_react/* useUnit */.eY)([$realEstateDistricts, $realEstateAddresses, getDistrictsFx, getAddressesFx]),
      _useUnit2 = (0,slicedToArray/* default */.Z)(_useUnit, 4),
      districtOptions = _useUnit2[0],
      addressOptions = _useUnit2[1],
      getDistricts = _useUnit2[2],
      getAddresses = _useUnit2[3];

  var _useUnit3 = (0,effector_react/* useUnit */.eY)([getDistrictsFx.pending, getAddressesFx.pending]),
      _useUnit4 = (0,slicedToArray/* default */.Z)(_useUnit3, 2),
      isDistrictsLoading = _useUnit4[0],
      isAddressesLoading = _useUnit4[1];

  var _watch = watch(),
      real_estate_address_state = _watch.real_estate_address_state;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Тип залога"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: control,
        name: "pledge_type",
        render: function render(_ref2) {
          var _fieldState$error;

          var field = _ref2.field,
              fieldState = _ref2.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* Select */.P, {
            value: (0,utils/* findOption */.ti)(pledgeTypes, field.value),
            onChange: function onChange(newValue) {
              return field.onChange(newValue.value);
            },
            errorMessage: (_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message,
            options: pledgeTypes,
            placeholder: t("\u0422\u0438\u043F \u0437\u0430\u043B\u043E\u0433\u0430"),
            noOptionsMessage: function noOptionsMessage() {
              return t("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
            }
          });
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Стоимость недвижимости"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "real_estate_price",
        control: control,
        render: function render(_ref3) {
          var _fieldState$error2;

          var field = _ref3.field,
              fieldState = _ref3.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, CollateralRealEstateFields_objectSpread(CollateralRealEstateFields_objectSpread({}, field), {}, {
            onChange: function onChange(e) {
              return field.onChange((0,lib/* setSpacesInNumber */.dX)((0,lib/* extractNumbers */.gW)(e.target.value)));
            },
            inputMode: "numeric",
            hasError: Boolean((_fieldState$error2 = fieldState.error) === null || _fieldState$error2 === void 0 ? void 0 : _fieldState$error2.message)
          }));
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Город/область"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: control,
        name: "real_estate_address_state",
        render: function render(_ref4) {
          var _fieldState$error3;

          var field = _ref4.field,
              fieldState = _ref4.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* Select */.P, {
            value: (0,utils/* findOption */.ti)(stateOptions, field.value),
            onChange: function onChange(newValue) {
              field.onChange(newValue.value);
              getDistricts(newValue.value);
              setValue("real_estate_address_district", "");
              setValue("real_estate_address_village", "");
            },
            hasError: Boolean(fieldState.error),
            errorMessage: (_fieldState$error3 = fieldState.error) === null || _fieldState$error3 === void 0 ? void 0 : _fieldState$error3.message,
            options: stateOptions,
            placeholder: t("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u043E\u0440\u043E\u0434/\u043E\u0431\u043B\u0430\u0441\u0442\u044C"),
            noOptionsMessage: function noOptionsMessage() {
              return t("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
            }
          });
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Город/регион"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: control,
        name: "real_estate_address_district",
        render: function render(_ref5) {
          var _fieldState$error4;

          var field = _ref5.field,
              fieldState = _ref5.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* Select */.P, {
            value: (0,utils/* findOption */.ti)(districtOptions, field.value),
            onChange: function onChange(newValue) {
              field.onChange(newValue.value);
              getAddresses({
                districtCode: newValue.value,
                stateCode: real_estate_address_state
              });
              setValue("real_estate_address_village", "");
            },
            hasError: Boolean(fieldState.error),
            errorMessage: (_fieldState$error4 = fieldState.error) === null || _fieldState$error4 === void 0 ? void 0 : _fieldState$error4.message,
            isLoading: isDistrictsLoading,
            options: districtOptions,
            isDisabled: !watch("real_estate_address_state") || isDistrictsLoading,
            placeholder: t("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u043E\u0440\u043E\u0434/\u0440\u0435\u0433\u0438\u043E\u043D"),
            noOptionsMessage: function noOptionsMessage() {
              return t("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
            }
          });
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Населенный пункт"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: control,
        name: "real_estate_address_village",
        render: function render(_ref6) {
          var _fieldState$error5;

          var field = _ref6.field,
              fieldState = _ref6.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* Select */.P, {
            value: (0,utils/* findOption */.ti)(addressOptions, field.value),
            onChange: function onChange(newValue) {
              return field.onChange(newValue.value);
            },
            hasError: Boolean(fieldState.error),
            errorMessage: (_fieldState$error5 = fieldState.error) === null || _fieldState$error5 === void 0 ? void 0 : _fieldState$error5.message,
            options: addressOptions,
            isLoading: isAddressesLoading,
            isDisabled: !watch("real_estate_address_district") || isAddressesLoading,
            placeholder: t("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u043D\u044B\u0439 \u043F\u0443\u043D\u043A\u0442"),
            noOptionsMessage: function noOptionsMessage() {
              return t("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
            }
          });
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalFormField/* HorizontalFormField */.g, {
      label: t("Улица, дом, квартира"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: "real_estate_full_address",
        control: control,
        render: function render(_ref7) {
          var _fieldState$error6;

          var field = _ref7.field,
              fieldState = _ref7.fieldState;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* Input */.I, CollateralRealEstateFields_objectSpread(CollateralRealEstateFields_objectSpread({}, field), {}, {
            hasError: Boolean((_fieldState$error6 = fieldState.error) === null || _fieldState$error6 === void 0 ? void 0 : _fieldState$error6.message)
          }));
        }
      })
    })]
  });
}
;// CONCATENATED MODULE: ./entities/Product/Application/ui/Step5Fields/index.tsx







function Step5Fields(_ref) {
  var pledgeTypes = _ref.pledgeTypes,
      states = _ref.states,
      brandOptions = _ref.brandOptions,
      productId = _ref.productId;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [productId === types/* CreditTypeEnum.PLEDGE_AUTO */.z.PLEDGE_AUTO && /*#__PURE__*/(0,jsx_runtime.jsx)(CollateralCarFields, {
      brandOptions: brandOptions
    }), productId === types/* CreditTypeEnum.PLEDGE_REAL_ESTATE */.z.PLEDGE_REAL_ESTATE && /*#__PURE__*/(0,jsx_runtime.jsx)(CollateralRealEstateFields, {
      pledgeTypes: pledgeTypes,
      stateOptions: states
    })]
  });
}
;// CONCATENATED MODULE: ./entities/Product/Application/ui/Step5/index.tsx



function Step5_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Step5_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Step5_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Step5_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














function ApplicationStep5(_ref) {
  var pledgeTypes = _ref.pledgeTypes,
      states = _ref.states,
      brandOptions = _ref.brandOptions;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useUnit = (0,effector_react/* useUnit */.eY)([$applicationFormStep5, submitApplicationStep5, $applicationStep, setApplicationStep, $applicationFormStep3]),
      _useUnit2 = (0,slicedToArray/* default */.Z)(_useUnit, 5),
      step5Data = _useUnit2[0],
      submitStep = _useUnit2[1],
      activeStep = _useUnit2[2],
      setActiveStep = _useUnit2[3],
      step3Data = _useUnit2[4];

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onChange",
    shouldUnregister: false,
    resolver: (0,zod/* zodResolver */.F)((0,utils/* applicationValidationStep5Schema */.U)(step3Data.credit_type, t)),
    defaultValues: step5Data
  });
  var onSubmit = methods.handleSubmit(function (data) {
    submitStep(data);
  });

  var goBack = function goBack() {
    setActiveStep(activeStep - 1);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Step5_StyledWrapper, {
    onSubmit: onSubmit,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, Step5_objectSpread(Step5_objectSpread({}, methods), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Step5Fields, {
        pledgeTypes: pledgeTypes,
        states: states,
        brandOptions: brandOptions,
        productId: step3Data.credit_type
      })
    })), /*#__PURE__*/(0,jsx_runtime.jsxs)(Step5_StyledBottom, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Step5_StyledPageBackButton, {
        onClick: goBack,
        color: "primary_red",
        label: t("\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430\u0437\u0430\u0434")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* Button */.z, {
        type: "submit",
        disabled: !methods.formState.isValid,
        children: t("\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C")
      })]
    })]
  });
}
var Step5_StyledWrapper = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "Step5__StyledWrapper",
  componentId: "sc-1bnkltb-0"
})(["display:grid;grid-gap:2.4rem;"]);
var Step5_StyledBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Step5__StyledBottom",
  componentId: "sc-1bnkltb-1"
})(["display:grid;margin-top:1.6rem;grid-template-columns:1.2fr 1.8fr;@media screen and (max-width:", "){grid-template-columns:1fr;grid-gap:3.2rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var Step5_StyledPageBackButton = (0,styled_components_browser_esm/* default */.ZP)(PageBackButton/* PageBackButton */.x).withConfig({
  displayName: "Step5__StyledPageBackButton",
  componentId: "sc-1bnkltb-2"
})(["@media screen and (max-width:", "){width:fit-content;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
;// CONCATENATED MODULE: ./entities/Product/Application/ui/FinalStep/index.tsx




function FinalStep_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FinalStep_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FinalStep_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FinalStep_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















function ApplicationFinalStep(_ref) {
  var cities = _ref.cities,
      periodOptions = _ref.periodOptions,
      creditAimOptions = _ref.creditAimOptions,
      classificationOptions = _ref.classificationOptions,
      pledgeTypes = _ref.pledgeTypes,
      creditTypeOptions = _ref.creditTypeOptions,
      stateOptions = _ref.stateOptions,
      carBrandOptions = _ref.carBrandOptions;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useUnit = (0,effector_react/* useUnit */.eY)([$applicationFormFinalStep, submitApplicationFinalStep]),
      _useUnit2 = (0,slicedToArray/* default */.Z)(_useUnit, 2),
      finalStep = _useUnit2[0],
      submitStep = _useUnit2[1];

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onChange",
    shouldUnregister: false,
    resolver: (0,zod/* zodResolver */.F)((0,utils/* applicationValidationSchema */.a2)(finalStep.credit_type, t)),
    defaultValues: finalStep
  });
  var onSubmit = methods.handleSubmit( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              submitStep(data);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
  (0,react.useEffect)(function () {
    var _methods$getValues = methods.getValues(),
        credit_type = _methods$getValues.credit_type,
        credit_period = _methods$getValues.credit_period,
        credit_sum = _methods$getValues.credit_sum;

    if (credit_type && credit_period && credit_sum) {
      var creditOption = (0,utils/* findOption */.ti)(creditTypeOptions, credit_type);
      var periodOption = (0,utils/* findOption */.ti)(periodOptions, credit_period);
      var period = (0,lib/* extractNumbers */.gW)(periodOption.label);
      var rate = creditOption.loan_rate;
      var sum = (0,lib/* extractNumbers */.gW)(credit_sum);
      methods.setValue("credit_monthly_payment", String((0,lib/* setSpacesInNumber */.dX)(Math.ceil((0,lib/* calcMonthlyPaid */.ez)(period, sum, rate)))));
    }
  }, [methods.watch("credit_type"), methods.watch("credit_period"), methods.watch("credit_sum")]);
  var hasCollateral = (0,react.useMemo)(function () {
    return [types/* CreditTypeEnum.PLEDGE_REAL_ESTATE */.z.PLEDGE_REAL_ESTATE, types/* CreditTypeEnum.PLEDGE_AUTO */.z.PLEDGE_AUTO].includes(methods.watch("credit_type"));
  }, [methods.watch("credit_type")]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledSubtitle, {
      tag: "p",
      color: "primary_light_gray",
      children: t("Проверьте ваши данные, и отредактируйте при необходимости, перед тем как отправить на рассмотрение.")
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FinalStep_StyledWrapper, {
      onSubmit: onSubmit,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, FinalStep_objectSpread(FinalStep_objectSpread({}, methods), {}, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSection, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledSectionTitle, {
            fontSize: "1.8rem",
            weight: 700,
            children: t("Персональные данные")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSectionContent, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Step2Fields, {
              cities: cities
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSection, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledSectionTitle, {
            fontSize: "1.8rem",
            weight: 700,
            children: t("Кредитная информация")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSectionContent, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Step3Fields, {
              periodOptions: periodOptions,
              creditAimOptions: creditAimOptions,
              creditTypeOptions: creditTypeOptions,
              carBrandOptions: carBrandOptions
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSection, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledSectionTitle, {
            fontSize: "1.8rem",
            weight: 700,
            children: t("Информация о работе")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSectionContent, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Step4Fields, {
              classificationOptions: classificationOptions
            })
          })]
        }), hasCollateral && /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSection, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledSectionTitle, {
            fontSize: "1.8rem",
            weight: 700,
            children: t("Информация о залоге")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSectionContent, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Step5Fields, {
              pledgeTypes: pledgeTypes,
              states: stateOptions,
              brandOptions: carBrandOptions,
              productId: finalStep.credit_type
            })
          })]
        })]
      })), /*#__PURE__*/(0,jsx_runtime.jsxs)(FinalStep_StyledBottom, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* Button */.z, {
          type: "submit",
          disabled: !methods.formState.isValid,
          children: t("\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C")
        })]
      })]
    })]
  });
}
var StyledSubtitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
  displayName: "FinalStep__StyledSubtitle",
  componentId: "sc-109cv25-0"
})(["margin-bottom:6.4rem;max-width:57.6rem;@media screen and (max-width:", "){margin-top:-2rem;margin-bottom:4rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var FinalStep_StyledWrapper = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "FinalStep__StyledWrapper",
  componentId: "sc-109cv25-1"
})(["display:grid;grid-gap:6.4rem;@media screen and (max-width:", "){grid-gap:3.2rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var FinalStep_StyledBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FinalStep__StyledBottom",
  componentId: "sc-109cv25-2"
})(["display:grid;margin-top:1.6rem;grid-template-columns:1.2fr 1.8fr;@media screen and (max-width:", "){grid-template-columns:1fr;grid-gap:3.2rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "FinalStep__StyledSection",
  componentId: "sc-109cv25-3"
})(["display:grid;grid-gap:2.4rem;@media screen and (max-width:", "){grid-gap:1.6rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledSectionTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
  displayName: "FinalStep__StyledSectionTitle",
  componentId: "sc-109cv25-4"
})(["display:grid;grid-gap:2.4rem;color:#67707a;"]);
var StyledSectionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FinalStep__StyledSectionContent",
  componentId: "sc-109cv25-5"
})(["display:grid;grid-gap:2.4rem;@media screen and (max-width:", "){grid-gap:1.6rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
;// CONCATENATED MODULE: ./entities/Product/Application/index.tsx
























function ApplicationForm(props) {
  var _router$query, _router$query3;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var _useUnit = (0,effector_react/* useUnit */.eY)([$applicationStep, setSuccessModalVisibility, $successModalVisibility, setCityApplicationStep2, setCreditTypeApplicationStep3, setClassificationApplicationStep4, resetApplicationForm]),
      _useUnit2 = (0,slicedToArray/* default */.Z)(_useUnit, 7),
      activeStep = _useUnit2[0],
      setIsSuccessModalVisible = _useUnit2[1],
      isSuccessModalVisible = _useUnit2[2],
      setCityStep2 = _useUnit2[3],
      setCreditTypeStep3 = _useUnit2[4],
      setClassificationStep4 = _useUnit2[5],
      resetForm = _useUnit2[6];

  var citiesOptions = (0,lib/* extractSelectOptions */.qc)(props.dictionaries.cities);
  var creditPeriodOptions = (0,lib/* extractSelectOptions */.qc)(props.dictionaries.credit_periods);
  var creditTargetOptions = (0,lib/* extractSelectOptions */.qc)(props.dictionaries.credit_targets);
  var depositTypeOptions = (0,lib/* extractSelectOptions */.qc)(props.dictionaries.pledge_types);
  var creditTypeOptions = (0,lib/* extractSelectOptions */.qc)(props.dictionaries.products);
  var classificationOptions = (0,lib/* extractSelectOptions */.qc)(props.dictionaries.classifications);
  var stateOptions = props.states.map(function (item) {
    return {
      value: String(item.code),
      label: item.name
    };
  });
  var brandsOptions = props.brands.map(function (item) {
    return {
      value: String(item.code),
      label: item.name
    };
  });

  var closeSuccessModal = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSuccessModalVisible(false);
              _context.next = 3;
              return router.push(routes/* routePaths.main.index */.X.main.index);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function closeSuccessModal() {
      return _ref.apply(this, arguments);
    };
  }();

  function getStepContent(step) {
    switch (step) {
      case 0:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ApplicationStep1, {});

      case 1:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ApplicationStep1Code, {});

      case 2:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ApplicationStep2, {
          cities: citiesOptions
        });

      case 3:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ApplicationStep3, {
          creditTypeOptions: creditTypeOptions,
          periodOptions: creditPeriodOptions,
          creditAimOptions: creditTargetOptions,
          carBrandOptions: brandsOptions
        });

      case 4:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ApplicationStep4, {
          classificationOptions: classificationOptions
        });

      case 5:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ApplicationStep5, {
          pledgeTypes: depositTypeOptions,
          states: stateOptions,
          brandOptions: brandsOptions
        });

      case 6:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ApplicationFinalStep, {
          cities: citiesOptions,
          creditTypeOptions: creditTypeOptions,
          periodOptions: creditPeriodOptions,
          creditAimOptions: creditTargetOptions,
          classificationOptions: classificationOptions,
          pledgeTypes: depositTypeOptions,
          stateOptions: stateOptions,
          carBrandOptions: brandsOptions
        });

      default:
        return "Unknown step";
    }
  }

  var stepperData = (0,utils/* getStepperData */.vq)(activeStep, t, (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.productId);
  (0,react.useEffect)(function () {
    return function () {
      resetForm();
    };
  }, []);
  (0,react.useEffect)(function () {
    var _creditTypeOptions$fi, _creditTypeOptions$fi2;

    setCityStep2(citiesOptions[0].value);
    setCreditTypeStep3((_creditTypeOptions$fi = (_creditTypeOptions$fi2 = creditTypeOptions.find(function (product) {
      var _router$query2;

      return product.value === ((_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.productId);
    })) === null || _creditTypeOptions$fi2 === void 0 ? void 0 : _creditTypeOptions$fi2.value) !== null && _creditTypeOptions$fi !== void 0 ? _creditTypeOptions$fi : "");
    setClassificationStep4(classificationOptions[0].value);
  }, [(_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.productId]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [activeStep < 6 && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledStepper, {
      step: stepperData.step,
      title: stepperData.title,
      percent: stepperData.percent
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: getStepContent(activeStep)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessModal/* SuccessModal */.i, {
      show: isSuccessModalVisible,
      onClose: closeSuccessModal,
      title: t("\u0412\u0430\u0448\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430!"),
      description: t("\u041C\u044B \u0441\u0432\u044F\u0436\u0435\u043C\u0441\u044F \u0441 \u0432\u0430\u043C\u0438 \u0432 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u043B\u0435 \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044F \u0432\u0430\u0448\u0435\u0439 \u0437\u0430\u044F\u0432\u043A\u0438"),
      buttonLabel: t("\u041F\u043E\u043D\u044F\u0442\u043D\u043E")
    })]
  });
}
var StyledStepper = (0,styled_components_browser_esm/* default */.ZP)(Stepper/* Stepper */.v).withConfig({
  displayName: "Application__StyledStepper",
  componentId: "sc-1xdmri9-0"
})(["margin-bottom:6.4rem;@media screen and (max-width:", "){margin-bottom:2.4rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
;// CONCATENATED MODULE: ./src/pages/main/product/application/index.tsx











var __N_SSP = true;
function ApplicationPage(props) {
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: t("\u0411\u041D\u041A \u0424\u0438\u043D\u0430\u043D\u0441 \u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D")
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContent, {
      $size: 928,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
        tag: "h1",
        weight: 700,
        fontSize: "3.2rem",
        children: t("\u041E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ApplicationForm, {
        dictionaries: props.dictionaries,
        states: props.states,
        brands: props.brands
      })]
    })]
  });
}

ApplicationPage.getLayout = function getLayout(page) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* Layout */.A, {
    children: page
  });
};

var StyledContent = (0,styled_components_browser_esm/* default */.ZP)(sharedstyles/* Container */.W).withConfig({
  displayName: "application__StyledContent",
  componentId: "sc-jbez4j-0"
})(["padding-top:6.4rem;padding-bottom:8.4rem;@media screen and (max-width:", "){padding-bottom:6.4rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
  displayName: "application__StyledTitle",
  componentId: "sc-jbez4j-1"
})(["margin-bottom:3.2rem;@media screen and (max-width:", "){margin-bottom:4.4rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});

/***/ }),

/***/ 1600:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/main/product/application",
      function () {
        return __webpack_require__(6102);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8359,1664,5675,2151,1358,7802,7536,3691,6508,301,4999,9774,2888,179], function() { return __webpack_exec__(1600); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);